/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


/**
 *
 * [ module ]
 * pdp -> buttons
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.buttons = lcmodule( function( exports ) {

		exports.moduleName = "pdp.buttons";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the buttons module
		 */
		ex.init = function() {

			_this.$pdpForm = 			$("#pdpGenuinePreOrderForm");

			_this.$priceData = 			$( "#pricedata" );

			_this.$add = 				$(".product-actions__add");
			_this.$addBtn = 			$("#btnAddToBag");

			_this.$checkout = 			$(".product-actions__checkout");
			_this.$checkoutBtn = 		$("#btnCheckout");
			_this.$checkoutForm = 		$("#globalMoveToCheckoutForm");

			_this.$wishlist = 			$(".product-actions__wishlist");
			_this.$wishlistBtn = 		$("#btnWishlist");

			_this.$instoreAvailability = 		$(".store-availability");
			_this.$instoreAvailabilityBtn = 	$("#btnStoreAvailability");

			_this.$qtyInput = 			$("#product-quantity");

			_this.$sizes =				$(".product-sizes");
			_this.$colors =				$(".product-colors");

			_this.$errorWrapper =		$(".product-error");

			_this.$errors = {
				size: _this.$errorWrapper.find(".product-error__size-not-selected"),
				color: _this.$errorWrapper.find(".product-error__color-not-selected"),
				stock: _this.$errorWrapper.find(".product-error__size-out-of-stock"),
				login: _this.$errorWrapper.find(".product-error__not-logged-in "),
				qty: _this.$errorWrapper.find(".product-error__quantity-error "),
				unavailable: _this.$errorWrapper.find(".product-error__size-unavailable"),
				other: _this.$errorWrapper.find(".product-error__other")
			};

			_this.urls = {

				ajaxResponseJson: 	"/common/form/globalAddItemAjaxResponseJson.jsp",

				inStore: 				"/stores/",
				addToBag: 				"/dialog/_revamp/pdp/add-to-bag.jsp",
				preOrder: 				"/dialog/_revamp/pdp/pre-order.jsp",
				instoreAvailability: 	"/dialog/_revamp/global/instore-availability.jsp"

			};

			_this.$availability = $(".availability");

			// generating HTML in the Javascript should be kept to a minimum.
			// if we do it, we should make sure it's very clean and easy to edit.
			_this.$spinner =
				$("<span class='" +
				  	"spinner spinner--tiny spinner--dark spinner--static " +
					" pos-r r-10 b-2 disp-ib va-m' />");

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();
			_this.addData = _this.$addBtn.data();
			_this.addButtonText = _this.$addBtn.text();

			ex.events();
			ex.subscribe();

		};

		ex.addButton = {

			isDisabled: false,

			loading: function( text ) {

				if ( typeof text === "undefined" ) {
					text = _this.addData.txtadding;
				}

				ex.addButton.show();
				ex.addButton.disable();
				ex.addButton.setText( text );
				ex.addButton.addSpinner();

			},

			disable: function() {

				ex.addButton.isDisabled = true;

				_this.$addBtn.toggleClass( ex.disabledClass, true );

			},

			enable: function() {

				ex.addButton.isDisabled = false;

				_this.$addBtn.toggleClass( ex.disabledClass, false );

			},

			hide: function() {

				_this.$add.toggleClass( ex.hiddenClass, true );

			},

			show: function() {

				_this.$add.toggleClass( ex.hiddenClass, false );

			},

			normal: function( text ) {

				text = text || _this.addButtonText;

				ex.addButton.show();
				ex.addButton.enable();
				ex.addButton.setText( text );
				ex.addButton.removeSpinner();

			},

			setText: function( text ) {

				_this.$addBtn.text( text );

			},

			addSpinner: function() {

				_this.$addBtn.prepend( _this.$spinner );

			},

			removeSpinner: function() {

				_this.$spinner.remove();

			},

			click: function() {

				if ( ex.addButton.isDisabled ) {
					return;
				}

				var status = _this.addData.status.toLowerCase();

				_this.clearStates();

				switch ( status ) {


					case "preorder":

						if ( _this.checkSelectedState() ) {

							_this.preOrder();

						}

						break;

					case "instoreonly":

						// this scenario handles sending
						// users to the "see all our stores" page,
						// but it's no longer in use since store-availability.
						// todo: remove this logic?
						_this.inStore();
						break;

					case "normal":
					case "giftcard":

						if ( _this.checkSelectedState() && _this.checkQuantityState() ) {

							_this.addProduct();

						}

						break;

					case "soldout":
					case "comingsoon":
					case "unavailable":
					default:

						break;

				}

			}

		};

		ex.checkoutButton = {

			show: function() {

				_this.$checkout.toggleClass( ex.hiddenClass, false );

			},

			hide: function() {

				_this.$checkout.toggleClass( ex.hiddenClass, true );

			},

			click: function() {

				_this.$checkoutForm.trigger("submit");

			}

		};

		ex.wishlistButton = {

			show: function() {

				_this.$wishlist.toggleClass( ex.hiddenClass, false );

			},

			hide: function() {

				_this.$wishlist.toggleClass( ex.hiddenClass, true );

			},

			click: function() {

				var skuId;

				if ( _this.checkSelectedState() ) {

					// otherwise, check that user has selected an skuId,
					// and show them an error if they didn't pick one.

					skuId = _this.getSelectedData().skuid;

				} else {

					return;

				}

				// track an event for clicking the
				// add to wishlist button
				LC.pubsub.trigger("pdp.trackClickAddWishlist", {
					productId: LC.pdp.general.getSelectedProductId()
				});

				LC.pubsub.trigger("wishlist.openWishlistAddModal", {
					skuId: skuId,
					method: "add",
					origin: "PDP"
				});

			}

		};

		ex.instoreAvailabilityButton = {

			show: function() {

				_this.$instoreAvailabilityBtn.toggleClass( ex.hiddenClass, false );

			},

			hide: function() {

				_this.$instoreAvailabilityBtn.toggleClass( ex.hiddenClass, true );

			},

			click: function() {

				var skuId,
					productId,
					size,
					selectedData,
					dialogUrl;

				if ( _this.checkSelectedState() ) {

					// otherwise, check that user has selected an skuId,
					// and show them an error if they didn't pick one.

					selectedData = _this.getSelectedData();

					skuId = selectedData.skuid;
					productId = selectedData.id;

				} else {

					return;

				}

				dialogUrl =
					new URI( _this.urls.instoreAvailability )
						.setQuery({
							skuId: skuId,
							productId: productId
						})
						.toString();

				LC.modal
					.ajax( dialogUrl, {
						name: "instore-availability"
					});

				// this is for tracking the opening of dialog
				size = LC.helpers.sizeFromSku( skuId );

				LC.pubsub
					.trigger( "pdp.trackClickInStoreAvailability", [ { size: size } ] );

			}

		};

		/**
		 * hide the user-errors from the page
		 */
		ex.removeErrors = function() {

			_this.$errorWrapper
				.find("[ class *= 'product-error__' ]")
				.addClass( ex.hiddenClass )
				.filter(".is-cloned")
				.remove();

		};

		/**
		 * Check if the quantity picker is OK in terms
		 * of the value it currently posesses.
		 *
		 * @return { Boolean } | true if the quantity is ok.
		 */
		_this.checkQuantityState = function() {

			var qty = parseInt( _this.$qtyInput.val(), 10 ),
				qtyMax = parseInt( _this.$qtyInput.attr("max"), 10 ),
				qtyMin = parseInt( _this.$qtyInput.attr("min"), 10 ),
				qtyOk = ( qty <= qtyMax && qty >= qtyMin );

			// if there is a quantity picker, then we
			// need to check the value is OK.
			if ( _this.$qtyInput.length && !qtyOk ) {

				_this.$errors.qty.removeClass( ex.hiddenClass );
				return false;

			// otherwise, lets just let it go. ❄️
			} else {

				return true;

			}

		};

		/**
		 * Check the state of the size radios, one of them
		 * must be selected to be considered valid.
		 *
		 * @param { Boolean } silent | should we be quiet (not show error) ?
		 * @return { Boolean } 		 | true if a radio is selected
		 */
		_this.checkSelectedState = function( silent ) {

			var selected = _this.$sizes.find( "select" ).val();

			if ( !LC.helpers.isSku( selected ) ) {

				if ( !silent ) {
					_this.$errors.size.removeClass( ex.hiddenClass );
				}

				return false;

			} else {

				return true;

			}

		};

		/**
		 * Get the data of the selected size
		 * @return { Object } | Data refererring to the selected size
		 */
		_this.getSelectedData = function() {

			var selectedData = _this.$sizes.find( "option:selected" ).data();

			if ( typeof selectedData === "undefined" ) {
				selectedData = _this.$colors.find( "input:radio:checked" ).data();
			}

			return selectedData;

		};

		/**
		 * remove the errors for all ui parts
		 */
		_this.clearStates = function() {

			_this.$errorWrapper
				.find("p")
				.addClass( ex.hiddenClass );

		};

		/**
		 * Send the user to the "instore" information
		 * page, using a prelaoder to make it seem less slow.
		 *
		 * this scenario handles sending
		 * users to the "see all our stores" page,
		 * but it's no longer in use since store-availability.
		 *
		 * todo: remove this method?
		 *
		 */
		_this.inStore = function() {

			LC.preloader
				.open()
				.done( function() {
					LC.location.href = _this.urls.inStore;
				});

		};

		/**
		 * Routing and serialization for adding a product,
		 * this will first serialize all the form data and
		 * update the #pdpdata object with the selected product
		 *
		 * after serialisation it will route the function through
		 * to add either a giftcard or a normal product
		 *
		 */
		_this.addProduct = function() {

			var formdata = {},
				$quantity = $("#product-quantity"),
				$giftCardValue = $("#giftCardValue"),
				selectedData = _this.getSelectedData();

			ex.addButton.loading();
			ex.removeErrors();

			formdata.productId = selectedData.id;
			formdata.skuId = selectedData.skuid || _this.pdpdata.defaultsizesku;
			formdata.quantity = Math.abs( parseInt( $quantity.val(), 10 ) ) || 1;
			formdata.limited = false;
			formdata.isGiftCard = $giftCardValue.length > 0;
			formdata.giftCardValue = $giftCardValue.val() || 0;

			// make sure the value is a positive integer
			if ( formdata.giftCardValue ) {
				formdata.giftCardValue = Math.abs( parseInt( formdata.giftCardValue.replace( /,/g, "" ), 10 ) );
			}

			LC.pubsub.trigger( "pdp.addToCart", formdata );
			ex.addItemToCart( formdata );

		};

		ex.addItemToCart = function( formdata ) {

			var item = { sku: formdata.skuId, quantity: formdata.quantity };

			// use the global cart add function which returns a promise
			LC.cart.general.addItem( item, undefined, formdata.isGiftCard, formdata.giftCardValue )
				.done(function( response ) {

					if ( response.isProcessSuccess ) {

						LC.pubsub.trigger( "cart.refresh", { type: "addToBag" });

						_this.addToBagDialog( formdata );
						ex.checkoutButton.show();

						if ( formdata.isGiftCard ) {
							LC.pubsub.trigger( "pdp.addGiftcard", formdata );
						} else {
							LC.pubsub.trigger( "pdp.addProduct", formdata );
						}

						_this.trackAddToCart( formdata );

					} else {

						_.each( response.errorList, function( error ) {

							var $error = _this.$errors.other.clone();

							$error
								.html( error.errorMessage )
								.removeClass( ex.hiddenClass )
								.addClass( "is-cloned" )
								.appendTo( _this.$errorWrapper );

						});

					}

				})

				.fail( function( response ) {

					LC.warn( "failed to submit Product to Cart." );
					LC.log( response );

				})

				.always( function() {
					ex.addButton.normal();
				});

		};

		/**
		 * handling for loading the add-to-bag dialog.
		 */

		_this.addToBagDialog = function( formdata ) {

			var dialogUrl = new URI( _this.urls.addToBag );

			dialogUrl.setQuery({

				productId: formdata.productId,
				skuId: formdata.skuId,
				quantity: formdata.quantity,
				isLimited: formdata.limited,
				isGiftCard: formdata.isGiftCard,
				giftCardPrice: formdata.giftCardValue

			});

			LC.modal
				.ajax( dialogUrl.toString(), {
					name: "add-to-bag"
				});

		};

		/**
		 * handling for loading the pre-order dialog.
		 */

		_this.preOrder = function() {

			var loggedIn = LC.config.getValue("profile").isUserHardLoggedIn,
				selectedData = _this.getSelectedData(),
				dialogUrl = new URI( _this.urls.preOrder );

			ex.removeErrors();

			if ( !loggedIn ) {

				_this.$errors.login.removeClass( ex.hiddenClass );
				return;

			}

			ex.addButton.loading( Lang[ "ajax.processing" ] );

			if ( !selectedData ) {
				selectedData = {
					id: _this.pdpdata.productId,
					skuid: _this.pdpdata.defaultsizesku
				};
			}

			dialogUrl.setQuery({

				productId: selectedData.id,
				skuId: selectedData.skuid,
				quantity: 0,
				isLimited: false

			});

			LC.modal
				.ajax( dialogUrl.toString(), {
					name: "pre-order"
				})
				.promise
				.always( function() {
					ex.addButton.normal();
				});

		};


		/**
		 * take the essential info from the REST, and then
		 * update the UI with each part needed.
		 *
		 * there's a small check for "mockData" which is manually
		 * set in the pdp.general.js file, this allows us to decide if
		 * the "sold-out" is truly sold out, or just mock data.
		 * For wishlist purposes. - We cannot add mockdata to the wishlist.
		 */
		_this.rebuild = function( response, isDifferent ) {

			var availabilityInfo = response.availabilityWidgetInfo,
				status = availabilityInfo.productStatus,
				showSizeLabel = response.isShowSizeLabel,
				text = _this.addData.txtaddtobag,
				showAddButton = true,
				showInstoreAvailabilityButton = true,
				showWishlistButton = ( !availabilityInfo.mockData ),
				someHasStock = _.some( response.sizeSwatchList, { hasStock: true });

			_this.addData.status = status;

			status = status.toLowerCase();

			switch ( status ) {

				case "instoreonly":

					text = _this.addData.txtinstore;
					showAddButton = false;

					// additional check for 0 inventory
					if ( response.inventory <= 0 ) {
						showInstoreAvailabilityButton = false;
					}

					break;

				case "comingsoon":

					showAddButton = false;
					showInstoreAvailabilityButton = false;

					break;

				case "preorder":

					text = _this.addData.txtpreorder;
					showInstoreAvailabilityButton = false;
					break;

				case "soldout":

					showAddButton = false;
					showWishlistButton = false;
					showInstoreAvailabilityButton = false;
					break;

				case "unavailable":

					// don't handle the unavailable status
					// if any of the sku-sizes (not size-labels) have stock.
					// This is so the user has to make an interaction before
					// showing "notify me".
					//
					// "isDifferent" just makes sure
					// the logic only runs when a productId is changed (color)
					if ( !showSizeLabel && isDifferent && someHasStock ) {
						break;
					}

					showAddButton = false;
					showInstoreAvailabilityButton = false;

					break;

				case "giftcard":

					showWishlistButton = false;
					showInstoreAvailabilityButton = false;
					break;

				case "normal":
				default:

					break;

			}

			if ( showAddButton ) {
				ex.addButton.show();
			} else {
				ex.addButton.hide();
			}

			if ( showWishlistButton ) {
				ex.wishlistButton.show();
			} else {
				ex.wishlistButton.hide();
			}

			if ( showInstoreAvailabilityButton ) {
				ex.instoreAvailabilityButton.show();
			} else {
				ex.instoreAvailabilityButton.hide();
			}

			_this.addButtonText = text;
			ex.addButton.setText( text );

		};

		/**
		 * refresh the UI
		 */
		ex.refresh = function( data ) {

			var response = data.response.atgResponse;
			_this.rebuild( response, data.isDifferent );

		};

		_this.trackAddToCart = function( item ) {

			var itemObj = LC.pdp.general.getPdpProduct( item.skuId );

			LC.track.trigger( "ecomm.addItem", itemObj );

		};

		ex.events = function() {

			_this.$addBtn
				.off(".pdpButton")
				.on("click.pdpButton", function(e) {

					e.preventDefault();
					ex.addButton.click();

				});

			_this.$checkoutBtn
				.off(".pdpButton")
				.on("click.pdpButton", function(e) {

					e.preventDefault();
					ex.checkoutButton.click();

				});

			_this.$wishlistBtn
				.off(".pdpButton")
				.on("click.pdpButton", function(e) {

					e.preventDefault();
					ex.wishlistButton.click();

				});

			_this.$instoreAvailabilityBtn
				.off(".pdpButton")
				.on("click.pdpButton", function(e) {

					e.preventDefault();
					ex.instoreAvailabilityButton.click();

				});

			_this.$pdpForm.on("submit.pdpSubmit", function(e) {

				e.preventDefault();
				ex.addButton.click();

			});


		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("buttons") ) {

					ex.refresh( data );
					ex.addButton.enable();

				}
			});

			LC.pubsub.on( "pdp.chooseSize pdp.chooseColor", function() {

				_this.clearStates();

				// check that we've selected a product
				// size/color before trying to disable
				// the "add to bag" button... if we've selected the first
				// item in the mobile-dropdown ("select size"),
				// then we don't want to disable the "add" button, we would
				// instead rely on the error-status to show the user
				// their error.

				if ( _this.getSelectedData() ) {
					ex.addButton.disable();
				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> availability
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.availability = lcmodule( function( exports ) {

		exports.moduleName = "pdp.availability";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the availability module
		 */
		ex.init = function() {

			_this.$availability = 		$(".availability");
			_this.$title = 				_this.$availability.children(".availability__title");
			_this.$message = 			_this.$availability.children(".availability__message");

			_this.$lastOne = 			$(".last-one");

			// get initial pdp data
			_this.qtydata = $("#qtydata").data();
			ex.subscribe();

		};

		ex.setState = function( options ) {

			_this.$availability.toggleClass( ex.hiddenClass, !options.show );
			_this.$availability.toggleClass( "bor-v1", options.borders );

		};

		ex.setTitle = function( title ) {

			_this.$title.text( title );

		};

		ex.setMessage = function( message ) {

			if ( message ) {

				_this.$message.html( message );
				_this.$message.removeClass( ex.hiddenClass );

			} else {

				_this.$message.addClass( ex.hiddenClass );

			}

		};

		/**
		 * Method to run during "initSizeSelect" to determine
		 * if we should be showing the "last one" message or not.
		 * This is needed because "last one" is sku-level, not product-level
		 * and the .jsp only handles product-level messages.
		 *
		 * @param  {Number} stock | the stock returned from the event
		 */
		ex.initLastOne = function( stock ) {

			ex.setLastOne( stock === 1 );

		};

		/**
		 * Method to set the display of the "last one" message
		 *
		 * @param {Boolean/String} lastOne | value to determine if we show/not.
		 */
		ex.setLastOne = function( lastOne ) {

			if ( lastOne === "true" || lastOne === true ) {

				_this.$lastOne.removeClass( ex.hiddenClass );

			} else {

				_this.$lastOne.addClass( ex.hiddenClass );

			}

		};

		/**
		 * take the essential info from the API, and then
		 * update the UI with each part needed.
		 */
		_this.rebuild = function( response, isDifferent ) {

			var availabilityInfo = response.availabilityWidgetInfo,
				status = availabilityInfo.productStatus,
				showSizeLabel = response.isShowSizeLabel,
				show = false,
				borders = false,
				someHasStock = _.some( response.sizeSwatchList, { hasStock: true });

			_this.qtydata.status = status;

			status = status.toLowerCase();

			switch ( status ) {

				case "soldout":
				case "instoreonly":
				case "unavailable":
				case "comingsoon":
				case "preorder":

					show = true;
					borders = true;
					break;

				case "normal":
				default:

					break;

			}

			// if we should show the unavailable message, we should check
			// that there's really no stock for any of the SKUs first...
			// and then check that a size is really selected

			if ( status === "unavailable" ) {

				// don't handle the unavailable status
				// if any of the sku-sizes (not size-labels) have stock. This is
				// so the user has to make an interaction before
				// showing "unavailable" message.
				//
				// "isDifferent" just makes sure
				// the logic only runs when a productId is changed (color)
				if ( !showSizeLabel && isDifferent && someHasStock ) {

					show = false;

				} else {

					show = true;

				}

			}

			ex.setTitle( availabilityInfo.title );
			ex.setMessage( availabilityInfo.text );
			ex.setLastOne( availabilityInfo.isLastOne );

			ex.setState({

				show: show,
				borders: borders

			});

		};

		/**
		 * refresh the UI
		 */
		ex.refresh = function( data ) {

			var response = data.response.atgResponse;
			_this.rebuild( response, data.isDifferent );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("availability") ) {
					ex.refresh( data );
				}
			});

			LC.pubsub.on( "pdp.initSizeSelect", function( e, data ) {
				ex.initLastOne( data.stock || 0 );
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> colorpicker
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	// dont initialise if there's no colour chip template.
	if ( !$("#tmpl-colorchip").length ) {
		return;
	}

	LC.pdp.colorpicker = lcmodule( function( exports ) {

		exports.moduleName = "pdp.colorpicker";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the color module
		 */
		ex.init = function() {

			_this.$productColors = $("#product-colors");
			_this.$colorlist = _this.$productColors.find(".product-colors__list");
			_this.$chipTemplate = $("#tmpl-colorchip");
			_this.$moreTemplate = $("#tmpl-colormore");
			_this.$colorName = _this.$productColors.find(".product-colors__title");

			_this.label = "lc-label";
			_this.labelActive = _this.label + "--active";
			_this.labelDisabled = _this.label + "--disabled";

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();

			_this.leftKey = 37;
			_this.upKey = 38;
			_this.rightKey = 39;
			_this.downKey = 40;

			_this.initSelected();
			_this.initLayout();

			ex.events();
			ex.subscribe();

		};



		/**
		 * set the initial selection attributes based either on the
		 * selected input (radio), or based on the default size sku data
		 */
		_this.initSelected = function() {

			var $selected = ex.getSelected();
			_this.selected = $selected.data("skuid");

			if ( !_this.selected ) {

				_this.selected = _this.pdpdata.defaultsizesku;

			}

			ex.setSelected();

		};

		_this.initLayout = function() {

			// first repace the <a> tags with <label>s so the user doesn't
		 	// accidentally change page after JS loaded.
			_this.$colorlist
				.find("a")
				.each( function( k, el ) {

					var $el = $(el),
						$label = $el.children("label");

					$el.replaceWith( $label );

				});

			ex.stackSwatches();
			ex.displayWidget();

		};

		/**
		 * method to figure out how many swatches
		 * we want to show (mobile/desktop) and then
		 * initialise the stack-a-thon !!
		 */
		ex.stackSwatches = function() {

			var limit = Foundation.MediaQuery.atLeast("tb") ? 20 : 5,
				selected = ex.getSelectedIndex();

			// sort out the swatch stacks.
			_this.$colorlist.lcStackSwatches({
				showArrow: true,
				selected: selected,
				limit: limit
			});

		};

		/**
		 * Method to display the widget when the page loads.
		 * This is because the swatch-stacking causes a
		 * flash-of-unstyled-colors, so we make it hidden
		 * in the JSP, then fade it in after stacking.
		 */
		ex.displayWidget = function() {

			_this.$productColors.removeClass("opc-0");

		};

		/**
		 * take the internal state of _this.selected,
		 * and apply the correct style and attributes
		 * to the tablet ui
		 *
		 * @param {String} sku | SKU to set as selected.
		 */
		ex.setSelected = function( sku ) {

			if ( sku && LC.helpers.isSku( sku ) ) {

				_this.selected = sku;

			}

			var $input = 	_this.$colorlist.find("[ data-skuid = '" + _this.selected + "' ]"),
				$label = 	$input.closest( "." + _this.label ),
				$others = 	_this.$colorlist.find( "." + _this.label ).not( $label );

			$label.addClass( _this.labelActive );
			$others.removeClass( _this.labelActive );
			$input.attr( "checked", true ).prop( "checked", true );

		};

		/**
		 * return the input that is selected.
		 */
		ex.getSelected = function() {

			return _this.$colorlist.find( "input:checked" );

		};

		/**
		 * return the index of the selected
		 * color in the colorlist, removing the
		 * breakers from the equation.
		 *
		 * @return { Integeter } | the index of the selected color, or 0.
		 */
		ex.getSelectedIndex = function() {

			var $selected = ex.getSelected(),
				index =
					$selected.parents( ".product-colors__item" )
						.index( ".product-colors__item:not( .breaker )" );

			if ( index < 0 ) {
				index = 0;
			}

			return index;

		};

		/**
		 * small method for correctly appending the
		 * new html template to the UI
		 */
		_this.append = function( html ) {

			_this.$colorlist
				.empty()
				.html( html );

		};

		/**
		 * create a UI "chip" from a handlebars template
		 * which we can add to the UI
		 * (https://app.frontify.com/d/6HJB4tyh5cb1/pattern-library#/atoms/color-chip)
		 *
		 * @param  {object} color 	| a single color-label object from atg.response
		 * @return {html}        	| returns a html string
		 */
		_this.createChip = function( color ) {

			var stateAttr = "",
				stateClass = "",
				chipStyle,
				template,
				loadingClass;

			if ( color.defaultSkuId === "" || color.publicationStatus === "Unpublished" ) {

				// need a proper spec to decide if this should
				// really be disabled, or if it just looks disabled.

				// stateAttr = "disabled";
				stateClass = _this.labelDisabled;

			} else if ( color.defaultSkuId === _this.selected ) {

				stateAttr = "checked";
				stateClass = _this.labelActive;

			}

			// `color.colorValue` would be `null` or `undefined` if no color
			if ( color.colorValue ) {
				chipStyle = "background-color: " + color.colorValue;
			}

			// `color.colorImage` would be `null` or `undefined` if no image
			if ( color.colorImage ) {
				loadingClass = "lc-label--loading opc-50 fade-in";
			}

			template = Handlebars.compile( _this.$chipTemplate.html() );

			return template({

				txtName: color.displayName,
				productUrl: color.productUrl,
				productId: color.productId,
				skuId: color.defaultSkuId,
				imagePath: color.colorImage,
				loadingClass: loadingClass,
				cssBg: chipStyle,
				stateAttr: stateAttr,
				stateClass: stateClass

			});

		};

		/**
		 * create a "more" arrow chip from the
		 * template in the .jsp file.
		 *
		 * @return {html} | a html string
		 */
		_this.createMoreArrow = function() {

			var template = Handlebars.compile( _this.$moreTemplate.html() );
			return template();

		};

		/**
		 * loop through all the colors, and update the
		 * ui with the new options available
		 * @param  {object} colors | atgResponse.colorSwatchList
		 */
		_this.rebuild = function( colors ) {

			if ( !colors.length ) {
				LC.info( "no colors returned from ATG, doing nothing." );
				return;
			}

			var html = "";

			$.each( colors, function( key, color ) {

				html += _this.createChip( color ) + " ";

			});

			// add the "more" arrow to the end (it's hidden)
			html += _this.createMoreArrow();

			_this.append( html.trim() );

			ex.stackSwatches();

		};

		_this.setName = function( name ) {

			var $selected;

			// try to set default name, if none supplied
			if ( !name ) {

				$selected = ex.getSelected();
				name = $selected.data( "displayname" );

			}

			// set name in UI if possible
			if ( name ) {

				_this.$colorName.text( name );

			// or display a warning
			} else {

				LC.warn( "cannot set display name for color" );

			}

		};

		/**
		 * method for handling key-presses on the color picker
		 *
		 * @param  { Event }  e 	| jQuery event object
		 */
		ex.handleKeyup = function( e ) {

			var $inputs = _this.$colorlist.find("input[type='radio']"),
				$selected = $inputs.filter(":checked"),
				$visible = $inputs.filter(":visible"),
				selectedIndex = $inputs.index( $selected ),
				jumpValue = 0,
				jumpDirection,
				newIndex;

			// figure out which key was pressed
			switch ( e.which ) {

				// if pressed "left", we want to go back
				// one color.
				case _this.leftKey:

					jumpValue = 1;
					jumpDirection = "backward";

					break;

				case _this.upKey:

					jumpValue = 5;
					jumpDirection = "backward";

					break;

				case _this.rightKey:

					jumpValue = 1;
					jumpDirection = "forward";

					break;

				case _this.downKey:

					jumpValue = 5;
					jumpDirection = "forward";

					break;

				default:
					break;

			}

			if ( jumpValue ) {

				e.preventDefault();

				if ( jumpDirection === "forward" ) {

					newIndex = selectedIndex + jumpValue;

				} else {

					newIndex = selectedIndex - jumpValue;

				}

				if ( newIndex < $inputs.index( $visible.first() ) ||
				    newIndex > $inputs.index( $visible.last() ) ) {

					LC.pubsub.trigger("pdp.openSwatchPicker", { type: "color" });

				} else {

					$inputs
						.eq( newIndex )
						.prop( "checked", true )
						.trigger( "change.colorpicker" );

				}

			}

			return e;

		};

		/**
		 * capture the keydown event for up/down arrows
		 * and prevent the action from interfering with
		 * our keyup event.
		 *
		 * @param  { Event } e | jQuery event object
		 */
		ex.handleKeydown = function( e ) {

			switch ( e.which ) {

				case _this.leftKey:
				case _this.upKey:
				case _this.rightKey:
				case _this.downKey:

					e.preventDefault();
					break;

				default:
					break;

			}

			return e;

		};

		/**
		 * method for programmatically changing the color
		 * @param  {string}  id  		  | Product Id
		 * @param  {string}  sku 		  | Product Sku
		 * @param  {boolean} forceRefresh | should we force a refresh on the swatch stack
		 */
		ex.change = function( id, sku, forceRefresh ) {

			LC.info( "changing color..." );
			LC.info( arguments );

			if ( !id || !sku ) {

				LC.warn( "cannot change color without an id / sku" );
				return;

			} else if ( !LC.helpers.isProduct( id ) || !LC.helpers.isSku( sku ) ) {

				LC.warn( "changing color failed due to invalid id / sku" );
				return;

			}

			_this.selected = sku;
			ex.setSelected();

			// set the colour name.
			_this.setName();

			var needRefresh = !_this.$productColors.data("isAvailableInColorGroup"),
				// only refresh the color picker if the original selected color
				// is considered not to be available in the color group. (see color-picker.jsp).
				not = needRefresh ? "" : "color";

			LC.pubsub.trigger( "pdp.chooseColor", {

				skuId: sku,
				productId: id,
				not: not, // list of modules to _not_ refresh. (color, size, etc)
				forceRefresh: forceRefresh

			});

			// once the color widget has been refreshed,
			// only available color need to be show
			// unavailable or sold out color will be excluded in response.colorSwatchList
			if ( needRefresh ) {
				_this.$productColors.data("isAvailableInColorGroup", true );
			}

		};

		/**
		 * refresh the user interface, with the new atg response
		 * @param  {object} data | atgResponse
		 */
		ex.refresh = function( data ) {

			var response = data.response,
				swatches = response.atgResponse.colorSwatchList,
				productId = response.atgResponse.essentialInfo.productId,
				thisColor = _.find( swatches, { productId: productId });

			// set the name for the colour if we find the defaultSkuId
			if ( thisColor ) {

				_this.selected = thisColor.defaultSkuId;
				_this.setName( thisColor.displayName );

			}

			// check that the product id is different
			// before trying to rebuild and load the swatches.
			if ( data.isDifferent ) {

				_this.rebuild( swatches );

				// use the color chip loader component to
				// lazy load the color chip images
				LC.pubsub.trigger( "bindChipLoader", {
					scope: _this.$productColors
				});

			}

		};

		ex.events = function() {

			// unbind all events first.
			_this.$colorlist.off(".colorpicker");

			// trigger color update when changing colour
			_this.$colorlist
				.on("change.colorpicker", "input[type='radio']", function(e) {

					var data = $( e.target ).data();
					// refer to ex.subscribe function,
					// set input param forceRefresh as true that is because
					// we would like to trigger the "focus" event
					ex.change( data.id, data.skuid, true );

				});

			// if we clicked on the "more" button, then we
			// trigger the swatch picker to open
			_this.$colorlist
				.on("click.colorpicker", ".product-colors__item--more", function() {

					LC.pubsub.trigger("pdp.openSwatchPicker", { type: "color" });

				});

			// trigger the swatch picker if we pressed
			// "right arrow" on the colour list's last item.
			_this.$colorlist
				.on( "keydown.colorpicker", "input[type='radio']", ex.handleKeydown )
				.on( "keyup.colorpicker", "input[type='radio']", ex.handleKeyup );

		};


		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {

				// if object "data" included properties "not" with value "color"
				// that mean ex.refresh will not be trigger
				if ( !data.not.includes("color") ) {

					// refresh the colorpicker if the
					// pdp ui is updated.
					ex.refresh( data );

				}

				if ( data.response.requestData.forceRefresh ) {

					// re-stack swatches if the colorpicker
					// was told not to update.
					ex.stackSwatches();
					// set focus to the colour we just picked.
					ex.getSelected().trigger("focus");

				}

			});

			LC.pubsub.on( "pdp.restackColor", ex.stackSwatches );

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> description
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.description = lcmodule( function( exports ) {

		exports.moduleName = "pdp.description";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the description module
		 */
		ex.init = function() {

			_this.$container = 		$(".title-description");
			_this.$data = 			$(".product-title");
			_this.$brand = 			_this.$container.find(".product-title__brand-name");
			_this.$title = 			_this.$container.find(".product-title__product-name");
			_this.$stylecode = 		_this.$container.find(".product-title__style-code");
			_this.$description = 	_this.$container.find(".product-description");
			_this.$accordion =		$("#accordionpanel1");

			ex.subscribe();

		};

		/**
		 * small method for correctly appending the
		 * new brand to the UI
		 */
		_this.replaceBrand = function( brand ) {

			var $which = _this.$brand.children("a");

			if ( !$which.length ) {
				$which = _this.$brand;
			}

			$which.empty().text( brand );
			_this.$data.data( "brandName", brand );

		};

		/**
		 * small method for correctly appending the
		 * new title to the UI
		 */
		_this.replaceTitle = function( title, color ) {

			var pageTitle = LC.pageInfo.$titles().eq(0).text();

			_this.$title
				.empty()
				.html( "<span class='show-for-sr'>" + color + "</span> " + title )
				.unorphanize();

			_this.$data.data( "productName", title );

			if ( color ) {
				pageTitle = pageTitle.split( " | " );
				pageTitle[ 2 ] = color;
				pageTitle = pageTitle.join( " | " );
				LC.pageInfo.updateTitles( pageTitle );
			}

		};

		/**
		 * small method for correctly appending the
		 * new description to the UI
		 */
		_this.replaceDescription = function( desc ) {

			_this.$description
				.add( _this.$accordion )
				.empty()
				.html( "<p>" + desc + "<p>" )
				.find("p")
				.unorphanize(2);

		};

		/**
		 * small method for correctly appending the
		 * new prodcut code to the UI
		 */
		_this.replaceStyleCode = function( code ) {

			_this.$stylecode
				.empty()
				.html( Lang.productCodePrefix + code );

		};


		/**
		 * take the essential info from the API, and then
		 * update the UI with each part needed.
		 */
		_this.rebuild = function( response ) {

			var essentialInfo = response.essentialInfo,
				colorName,
				colorSwatch = response.colorSwatchList.filter(function( clr ) {
					return clr.productId === essentialInfo.productId;
				});

			if ( colorSwatch ) {
				colorName = colorSwatch[ 0 ].displayName;
			}

			_this.replaceBrand( essentialInfo.brandName );
			_this.replaceTitle( essentialInfo.displayName, colorName );
			_this.replaceDescription( essentialInfo.description );
			_this.replaceStyleCode( essentialInfo.productCode );

		};

		/**
		 * refresh the UI only if the response data was
		 * different to the original data and also different
		 * to the previous response.
		 */
		ex.refresh = function( data ) {

			var response = data.response.atgResponse;
			_this.rebuild( response );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("description") && data.isDifferent ) {
					ex.refresh( data );
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> general
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.general = lcmodule( function( exports ) {

		exports.moduleName = "pdp.general";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		ex.init = function() {

			_this.pdpdata = $("#pdpdata").data();
			_this.bodydata = $("body").data();

			_this.$canonical = $("link[ rel = \"canonical\" ]");
			_this.$priceMeta = $("meta[ property = \"product:price:amount\" ]");

			_this.$priceData = $( "#pricedata" );
			_this.$productTitle = $( ".product-title" );
			_this.$quantity = $( "#product-quantity" );
			_this.$giftCardValue = $("#giftCardValue");

			ex.checkAndRemoveFromUrl();
			ex.subscribe();

		};

		_this.trackViewPdp = function( skuId ) {

			var pdpProductItem = ex.getPdpProduct( skuId );

			LC.track.trigger( "ecomm.viewItem", pdpProductItem );

		};

		ex.getPdpProduct = function( skuId ) {

			var dataLayerInfo = window.LCDataLayer[ 0 ],
				brandName = dataLayerInfo.brand,
				currencyCode = dataLayerInfo.currencyCode,
				productName = _this.$productTitle.data( "product-name" ),
				$chosenSize = $( "#sizepicker__select" ).find( ":selected" ),
				$chosenColor = $( ".lc-label--colour.lc-label--active" ),
				originalPrice = _this.$priceData.data( "originalprice" ),
				salePrice = _this.$priceData.data( "currentprice" ),
				chosenColor = $chosenColor.attr( "title" ) || "",
				quantity = 1,
				itemObj;

			originalPrice = parseFloat( originalPrice );
			salePrice = parseFloat( salePrice );

			if ( typeof skuId === "undefined" ) {
				skuId = $chosenSize.val();
			}

			if ( _this.$quantity.length ) {
				quantity = parseInt( _this.$quantity.val(), 10 );
			}

			if ( _this.$giftCardValue.length ) {
				salePrice = _this.$giftCardValue.val() || 0;
				originalPrice = salePrice;
			}

			itemObj = {
				skuId: skuId,
				brandName: brandName,
				name: productName,
				quantity: quantity,
				salePrice: salePrice,
				originalPrice: originalPrice,
				discount: originalPrice - salePrice,
				currencyCode: currencyCode,
				variant: chosenColor
			};

			return itemObj;

		};

		/**
		 * returns whether we should do a recent product view addition.
		 *
		 * @param  { String } productId  | 	Id of the product to check is different
		 *                  				to the previous product
		 *
		 * @return { Boolean }           | 	If the supplied productID is difference.
		 */
		_this.differentProduct = function( productId ) {

			var ret = false;

			// first try to get details from the previous response
			// but if this is the first ajax, then there's no previous response.
			if ( typeof ex.previousResponse !== "undefined" ) {

				if ( ex.previousResponse.atgResponse.essentialInfo.productId !== productId ) {

					ret = true;

				}

			// if there's no previous response, then we use the
			// pdpdata to get the productId of initial request
			} else if ( _this.pdpdata.productId !== productId ) {

				ret = true;

			}

			return ret;

		};

		_this.getProductData = function( ajaxData ) {

			if ( !ajaxData || !ajaxData.productId || !ajaxData.skuId ) {
				return;
			}

			ajaxData.locale = 		ajaxData.locale || 		_this.bodydata.locale;
			ajaxData.profileId  =	ajaxData.profileId || 	_this.pdpdata.profileId;
			ajaxData.cardTier = 	ajaxData.cardTier || 	_this.pdpdata.cardTier;
			ajaxData.mps = 			ajaxData.mps || 		_this.pdpdata.mps;
			ajaxData.country =		ajaxData.country || 	_this.bodydata.profileCountry;

			/**
			 * check if we should fire a recentView event to server
			 */
			if ( typeof ajaxData.recentView === "undefined" ) {
				ajaxData.recentView = _this.differentProduct( ajaxData.productId );
			}

			/**
			 * kill the existing ajax call
			 */
			if ( typeof _this.ajax !== "undefined" ) {
				_this.ajax.abort();
			}

			_this.ajax = LC.product.getProductData( ajaxData );

			_this.ajax.done( function( response ) {

				response.requestData = ajaxData;

				ex.refresh({

					not: ajaxData.not,
					response: response,
					isDifferent: ajaxData.recentView

				});

				ex.previousResponse = response;

			});

			_this.ajax.fail( function( xhr, status ) {

				// don't refresh during an abort so the user
				// doesn't get redirected upon slow network.
				if ( status !== "abort" ) {

					// simply try to refresh the browser if the
					// ajax failed. Probably a session timeout.
					LC.location.reload();

				}

			});

		};

		/**
		 * method to remove the "from=..." query string parameter
		 * from the URL of the page.
		 */
		ex.checkAndRemoveFromUrl = function() {

			var queries = URI.parseQuery( URI().query() );

			// add any query params to the "LC.queryparams" object
			// for easy reference
			LC.queryparams = queries || {};

			if ( queries.from ) {
				history.replaceState( null, null, URI().removeQuery("from").toString() );
			}

		};

		/**
		 * Method to update the history state (url) with
		 * the new canonical url. Also maintain any fragments
		 *
		 * @param { String } url | The url to update state with.
		 */
		_this.setUrl = function( url ) {

			var fullUrl = URI( LC.location ).origin() + url,
				fragment = new URI().fragment(),
				newUrl;

			if ( url ) {

				newUrl = new URI( url ).fragment( fragment );
				history.replaceState( null, null, newUrl );
				_this.$canonical.attr( "href", fullUrl );

			}

		};

		/**
		 * method to update the PDP data object
		 *
		 * @param { Object } response  | The response data
		 */
		_this.setPdpData = function( response ) {

			_this.pdpdata.skuId = response.requestData.skuId;
			_this.pdpdata.productId = response.requestData.productId;
			_this.pdpdata.stylecode = response.atgResponse.essentialInfo.lcStyleCodes;
			_this.pdpdata.instoreOnly = (
				response.atgResponse.availabilityWidgetInfo.isInStoreOnly === true ||
				response.atgResponse.availabilityWidgetInfo.isInStoreOnly === "true" );

		};

		/**
		 * Method to update the LCDataLayer with new values returned
		 * from teh server during product updates.
		 *
		 * @param { Object } response  | The response data
		 */
		_this.setDataLayer = function( response ) {

			// we can't update prices because the returned prices
			// from the server do not have any format we can
			var datalayer = _.extend( {}, window.LCDataLayer[ 0 ] );

			datalayer.productId =
				response.atgResponse.essentialInfo.productId;

			datalayer.styleCode =
				response.atgResponse.essentialInfo.lcStyleCodes;

			datalayer.thumbnail =
				LC.format.productImage( response.atgResponse.essentialInfo.heroImage, "xs" );

			datalayer.title =
				response.atgResponse.essentialInfo.displayName;

			datalayer.url =
				new URI().origin() + response.atgResponse.essentialInfo.url;

			window.LCDataLayer.push( datalayer );

		};

		/**
		 * small helper to figure out the selected SKU from
		 * the data on the page.
		 * @return { String } | sku id
		 */
		ex.getSelectedSku = function() {

			// try to get the SKU frmo the selected radio
			var sku = $(".sizepicker__select option:selected").data( "skuid" );
			LC.log( "selected SKU is: " + sku );

			// if not, then try get it from the pdpdata
			if ( !LC.helpers.isSku( sku ) ) {
				sku = $("#pdpdata").data("sku-id");
			}

			return sku;

		};

		/**
		 * small helper to figure out the selected PID from
		 * the data on the page.
		 * @return { String } | product id
		 */
		ex.getSelectedProductId = function() {

			// try to get the SKU frmo the selected option
			var pid = $(".product-sizes__select option:selected").data( "id" );

			// if not, then try get it from the pdpdata
			if ( !LC.helpers.isProduct( pid ) ) {
				pid = $("#pdpdata").data("productId");
			}

			return pid;

		};

		/**
		 * small helper to figure out if the current
		 * product is a giftcard or not.
		 * @return { Boolean }
		 */
		ex.isAGiftcard = function() {

			return $("#qtydata").data().status === "giftCard";

		};

		/**
		 * decide whether to display the whole size picker widget, or not.
		 * @param { object } response | atgResponse
		 */
		ex.showSizeWidget = function( response ) {

			var statusAllowsShow = response.atgResponse.isProductStatusShowSizeWidget,
				showSizeLabel = response.atgResponse.isShowSizeLabel,
				sizes = response.atgResponse.sizeSwatchList,
				multipleSizes = ( sizes.length > 1 ),
				visible;

			/**
			 * we first check the "isProductStatusShowSizeWidget" value as the
			 * most truthful, but then we rely on other logic.
			 *
			 * quite complex, I suggest looking in size-picker.jsp for more
			 * hints on the complexity.
			 *
			 */

			visible =
				statusAllowsShow &&
				(
				 	multipleSizes ||
					( !multipleSizes && showSizeLabel )
				);

			return visible;

		};

		/**
		 * mostly error handling before emitting the pdp update event
		 * @param  { response } data | the response object from ATG
		 */
		ex.refresh = function( data ) {

			var response, not;

			if ( typeof data === "undefined" ||
			    typeof data.response === "undefined" ) {

				response = ex.previousResponse;
				LC.warn( "no data to refresh UI with, using previous response." );

			} else {

				response = data.response;
				not = data.not || "";

			}

			_this.pdpdata.productId = response.atgResponse.essentialInfo.productId;
			_this.pdpdata.skuId = "";
			_this.pdpdata.defaultsizesku = "";

			/**
			 * Check if the request had "mockData" in it, if so
			 * then we want to simulate a "soldOut" response from the
			 * server as that product can not be reserved, or in stock later.
			 */
			if ( response.requestData.skuId.includes("mockData") ) {

				_.extend( response.atgResponse.availabilityWidgetInfo, {

					productStatus: "soldOut",
					title: Lang[ "productDetails.soldout.text" ],
					text: Lang[ "productDetails.soldout.text2" ],
					mockData: true

				});

			}

			// update the page/url with the new product's data
			_this.setUrl( response.atgResponse.productUrl );
			_this.setPdpData( response );
			_this.setDataLayer( response );

			_this.$productTitle.data( "productName", response.atgResponse.essentialInfo.displayName );

			LC.pubsub.trigger( "pdp.update", {

				not: not,
				response: response,
				previousResponse: ex.previousResponse,
				isDifferent: data.isDifferent

			});

			_this.trackViewPdp( response.requestData.skuId );

		};


		ex.subscribe = function() {

			LC.pubsub.on(

				"pdp.chooseColor " +
				"pdp.chooseSize " +
				"pdp.getProduct",

				function( e, data ) {

					_this.getProductData( data );

				}
			);

			LC.pubsub.on( "pdp.initViewProduct", function( e, skuId ) {

				_this.trackViewPdp( skuId );

			} );

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> heropopup
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.heropopup = lcmodule( function( exports ) {

		exports.moduleName = "pdp.heropopup";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		ex.mobile = {};
		ex.desktop = {};

		_this.selected = 0;

		/**
		 * initialise the heropopup module
		 */
		ex.init = function() {

			_this.$bg = 				$("html, body");
			_this.$heroContainer = 		$(".product-hero");
			_this.$heroCarousel = 		$(".product-hero__carousel");
			_this.$thumbsContainer = 	$(".product-thumbnails");

			ex.subscribe();
			ex.events();

		};

		ex.setup = function() {

			ex.$modalrow =		$("<div class=\"hero-modal / row expanded\" />");
			ex.$modalthumbs = 	$("<div class=\"hero-modal__thumbs / txt-c\" />");
			ex.$modalhero = 	$("<div class=\"hero-modal__hero\" />");

			// first we clone the hero carousel, and then
			// drill down to the image container for each
			// hero image. Remove the css-styles that were
			// given by the carousel and remove any classes.
			// Finally we give it back a position-relative class
			// and then wrap all the images in a container so we
			// have a way to style the group.
			ex.$images =
				_this.$heroCarousel
					.clone()
					.find(".hero-image")
					.removeClass()
					.removeAttr("style")
					.addClass("pos-r cur-zo");

			// if any of the image containers have
			// blurry images, or spinners left in them we
			// remove them.
			//
			// (due to slow network speeds allowing the popup to open
			// before the images loaded).
			ex.$images
				.find(".blur")
				.remove();

			// move the spinner to the top
			ex.$images
				.find(".spinner")
				.css("z-index", 1 );

		};

		/**
		 * Method for launching the modal hero display, this will
		 * check the screen size, and run the correct launch accordingly
		 *
		 * @param  { Number } index | index of image to start the modal displaying
		 */
		ex.launch = function( index ) {

			if ( typeof index === "undefined" ) {
				index = 0;
			}

			_this.selected = index;

			// launch the desktop interface for both
			// tablet and desktop
			if ( Foundation.MediaQuery.atLeast("tb") ) {

				ex.desktop.launch( index );
				ex.desktop.events();

				// pubsub mostly for tracking the popup opening
				LC.pubsub.trigger("pdp.heroPopup", {
					index: index
				});

			}

		};

		ex.desktop.launch = function( index ) {

			// make sure the hero popup
			// is setup properly before launching
			ex.setup();

			index = index || 0;

			var $modal,
				$thumbs = _this.$thumbsContainer.clone();

			ex.$modalhero.append( ex.$images );
			ex.$modalthumbs.append( $thumbs );
			ex.$modalrow.append( ex.$modalthumbs, ex.$modalhero );

			// remove title attribute from all hero images
			ex.$modalhero.find(".hero-image__img").removeAttr("title");

			// use a fullscreen modal to display
			// the hero popup
			$modal = LC.modal.open( ex.$modalrow, {
				style: "full"
			});

			// make the hero image container 100% height
			// and scrollign so the images are stacked nicely
			// on top of each other
			ex.$modalrow
				.css({ height: "100%" });

			ex.$modalhero
				.addClass("ofy-s")
				.css({ height: "100%" });

			// make sure the close button is styled
			// so that it sits on top of the images
			// and looks nice and big
			$modal
				.closest(".ui-dialog")
				.attr("id", "pdp-hero-modal")
				.find(".ui-dialog-titlebar-close")
				.addClass("bg-white txt-20 pad-20");

			// give the thumbs a nice layout
			// and remove the black border
			$thumbs
				.removeClass()
				.addClass("product-thumbnails")
				.find(".product-thumbnails__thumb")
				.removeClass("bor-black")
				.css({ display: "block" })
				.find(".product-thumbnails__img")
				.removeAttr("title");

			// initialise carousel with the correct
			// image displayed.
			_this.jumpToImage( index );

			// start loading anything that didnt
			// finish when we opened the modal.
			_this.lazyloadImages();

			// when the modal closes, set the hero image
			// which will move the carousel.
			// We do this on close, and not on every thumb
			// selection because that causes a lot of background
			// JS to run and to slow the performance.
			$modal.on("dialogclose", function() {

				// set the main hero image, too.
				LC.pubsub.trigger("pdp.setImage", {
					index: _this.selected
				});

			});

		};

		_this.lazyloadImages = function() {

			// now we check each image to see if it is
			// an "xs" image, if it is then we give it
			// a xl lazy tag, so we can lazy-load :)

			ex.$images
				.find("img")
				.not("[ src *= '_xl']")
				.each( function( k, el ) {

					var xl = LC.format.productImage( el.src, "xl" );

					// we use a huge grace, as this container
					// doesn't actually scroll the window, so we
					// need to load all images regardless of scroll position.

					$(el)
						.data( "lazy", xl )
						.lazy({
							extraBlurry: true,
							instant: true
						});

				});


			// also attempt to lazy-load any thumbs
			// that were not previously loaded properly
			// due to network issues.
			ex.$modalthumbs
				.find("img")
				.lazy({
					instant: true
				});

		};

		_this.jumpToImage = function( index ) {

			var offset = ex.getCenterOfImage( index );

			// perform a small animation to demonstrate to the user
			// that the screen is scrollable, and also that there is
			// an image below. Has to be called after a single frame
			// has rendered, otherwise it won't scroll.
			window.requestAnimationFrame(function() {

				ex.$modalhero.scrollTop( offset + 100 );
				_this.scrollToImage( index );

			});

		};

		_this.scrollToImage = function( index ) {

			var offset = ex.getCenterOfImage( index );

			requestAnimationFrame( function() {
				ex.$modalhero.animate({ scrollTop: offset }, 300 );
			});

		};

		/**
		 * Method to find the center point of the screen when viewing
		 * a specified hero-popup image, allowing us to rest the screen
		 * nicely on an image with the highest probability of it not being
		 * just white-space
		 *
		 * @param  { Number } index | The index of hte image we want to center on
		 * @return { Number }       | The pixel value of the vertical center of the screen
		 */
		ex.getCenterOfImage = function( index ) {

			var imgHeight = ex.$modalhero.children().first().dimensions().height,
				windowHeight = $( window ).height(),
				viewableTop = 0,
				imgTop = imgHeight * index;

			// imageCenter is the decimal representation of
			// where on the image we want to focus the center
			if ( !_this.imageCenter ) {
				_this.imageCenter = 0.6;
			}

			// figure out the top of the viewport based on the
			// center of the image and the center of the window
			// and the part we clicked on
			viewableTop = ( imgHeight * ( index + _this.imageCenter ) ) - ( windowHeight / 2 );

			if ( viewableTop < imgTop ) {

				// if the screen is going to be above the image,
				// then set it to the top of the image exactly.
				viewableTop = imgTop;

			} else if ( viewableTop + windowHeight > imgTop + imgHeight ) {

				// if the bottom of the screen is going to be
				// below the image, set it to the bottom of
				// the image exactly
				viewableTop = imgTop + imgHeight - windowHeight;

			}

			return viewableTop;

		};

		ex.desktop.events = function() {

			var $hero = ex.$modalhero,
				$thumbs = ex.$modalthumbs.find(".product-thumbnails__thumb");

			$hero.off(".pdphero");
			$thumbs.off(".pdphero");

			$thumbs
				.checkmove()
				.on("click.pdphero touchend.pdphero", function(e) {

					var $el = $(this),
						index = $el.index(),
						touch,
						offset,
						ratio;

					if ( !$el.data("touchmoved") ) {

						e.preventDefault();

						touch = e.originalEvent.changedTouches;
						offset = e.originalEvent.offsetY;
						ratio = 0.6;

						if ( touch ) {

							// if we detect the event has touch-properties, then
							// we switch the offset to use the touch properties to
							// determine the clicked part of the image
							offset = touch[ 0 ].pageY - $el.dimensions().offset.top;

						}

						if ( offset ) {

							// ratio is the decimal-representation of the part
							// of the image we want to focus at the center of the
							// screen.
							ratio = parseFloat(( offset / $el.height()).toFixed(3));

						}

						_this.selected = index;
						_this.imageCenter = ratio;
						_this.scrollToImage( index );

					}

				});

			setTimeout(function() {

				// this event needs to be stuck in a timeout which
				// is longer than the click-delay of a mobile browser, because
				// otherwise the modal will close instantly after opening
				// due to the delayed click firing on the element.

				$hero
					.checkmove()
					.on("click.pdphero touchend.pdphero", function(e) {

						// the test for "checkmove" data needs to be async,
						// because there's a chance that the events fire
						// out of order and the "touchlong" data is not yet
						// correctly applied. So we use setTimeout for async.

						setTimeout( function() {

							if ( !$hero.data("touchmoved") &&
								!$hero.data("touchlong") &&
								!$hero.data("touchmulti")) {

								e.preventDefault();
								LC.modal.close( $( "#pdp-hero-modal" ) );

							}

						}, 10 );

					});

			}, 300 );

		};

		ex.events = function() {

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.openHeroModal", function( e, data ) {

				var index = 0;

				if ( data ) {

					index = data.index || 0;
					_this.imageCenter = data.imageCenter;

				}

				ex.launch( index );

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> hero
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.hero = lcmodule( function( exports ) {

		exports.moduleName = "pdp.hero";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		ex.fragmentKey = "selectedImage";

		/**
		 * boolean for tracking if the carousel has
		 * been initialised or not
		 * @type {Boolean}
		 */
		_this.carouselInitialised = false;

		/**
		 * initialise the hero module
		 */
		ex.init = function() {

			_this.$container = 		$(".product-hero");
			_this.$carousel = 		$(".product-hero__carousel");
			_this.$heroTemplate = 	$("#tmpl-hero-image");

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();

			// get the query fragment indexes for use
			// with auto-selecting an image.
			_this.selectedIndex = _this.getCarouselQueryIndex();
			_this.delayedIndex = _this.getCarouselFragmentIndex();

			// we need to know the "last index" for preventing
			// firing a "view" event if user views the same index twice.
			_this.lastIndex = _this.selectedIndex;

			/*
				normally, we would load the hero
				images here using "ex.loadHeros();", but
				we do that inline in the jsp, so there's no need.
			*/
			ex.removeComingSoonImages();

			ex.subscribe();
			ex.events();
			ex.singleHeroEvents();

			// this needs to be async so that other modules have
			// had time to initialise and set up subscriptions.
			setTimeout( function() {

				ex.initCarousel();

			}, 200 );

		};

		/**
		 * small method for correctly appending the
		 * new html template to the UI
		 */
		_this.append = function( html ) {

			_this.$carousel
				.empty()
				.html( html );

		};

		/**
		 * Show spinner for given $hero wrapper.
		 * Add it to the hero if it is not already there,
		 * but it should already be there at load time from .jsp
		 */
		ex.showSpinner = function( $hero ) {

			var $spinner = $hero.find(".spinner");

			if ( !_.size( $spinner ) ) {

				$spinner = $( "<span class=\"spinner opc-0\" />" );
				$hero.append( $spinner );

			}

			requestAnimationFrame(function() {

				$spinner.removeClass("opc-0");

			});

		};

		/**
		 * errr.... like.... hide the spinner for that $hero.
		 * ( also; remove it. )
		 */
		ex.hideSpinner = function( $hero ) {

			var $spinner = $hero.find(".spinner");

			$spinner.addClass("opc-0");

			// wait for animation to finish.
			setTimeout( function() {
				$spinner.remove();
			}, 300);

		};

		/**
		 * Method to begin loading all the hero images
		 */
		ex.loadHeros = function() {

			_this.$container
				.find(".hero-image")
				.each( function() {

					var $el = $(this);
					ex.loadLargeImage( $el );

				});

		};

		/**
		 * Method to loop through the images on the page
		 * and remove any "coming soon" images when the carousel
		 * has more than one image displayed. (if it errors the large image)
		 *
		 * This is so the user doesn't have to see "coming soon"
		 * for images when there's other images for them to see.
		 */
		ex.removeComingSoonImages = function() {

			var $imgs = _this.$carousel.find(".hero-image--xs");

			// don't do anything if there's only one image.
			// this is because the user needs to know that images
			// are coming soon when there's no images to display.
			if ( $imgs.length <= 1 ) {
				return;
			}

			$imgs.each(function() {

				var $this = $(this),
					img = new Image(),
					resolution = $this.closest(".hero-image").data("res-l");

				img.onerror = function() {

					$this.closest(".hero-image").remove();
					LC.warn( "broken hero image, removing hero:" + resolution );

				};

				img.src = resolution;

			});

		};

		/**
		 * main method for loading a hero image, just provide a hero
		 * wrapper ( .hero-image ) and it will do a beautiful loading visual
		 * by placing a new, hidden image on top and then fading it in when
		 * loaded
		 *
		 * @param  { $el } $hero | jQuery object with a single hero container
		 */
		ex.loadLargeImage = function( $hero ) {

			// error handling, don't try to load a non-existant image.
			if ( typeof $hero === "undefined" || !$hero.length ) {

				LC.warn( "tried to run ex.loadLargeImage without a `$hero`" );
				return;

			}

			var $sourceImage = $hero.children(".hero-image__img").eq(0),
				$largeImage = $sourceImage.clone(),
				resolution = $hero.data( "res-l" ),
				notFoundImage = LC.config.getValue("url.productImageNotFound-l"),
				img = new Image(),
				showHero,
				removeHero,
				spinnerDelay = 300;

			// clone the xs image and remove the blur
			$largeImage
			 .removeClass("blur opc-0 pos-a t-0 l-0 r-0 b-0")
			 .addClass("large-image")
			 .appendTo( $hero );

			// then make sure the source is displayed correctly
			$sourceImage
			 .addClass("blur an-long fade pos-a t-0 l-0 r-0 b-0")
			 .removeClass("large-image opc-0");

			// method to handle showing the hero nicely
			showHero = function() {

				// update the source to be "large"
				$largeImage.attr({ src: resolution });

				// this fades the blurred image back to normal
				requestAnimationFrame(function() {
					$sourceImage.addClass("opc-0");
				});

				// use a timer to hide the spinner, as it
				// might be loading so fast it was only just
				// added to the DOM and therefore would blink
				setTimeout(function() {

					LC.pdp.hero.hideSpinner( $hero );

				}, spinnerDelay );

				// use a short delay to remove the original
				// image from the DOM so we don't end up with tons
				// of crap hanging around.
				setTimeout( function() {

					$sourceImage.remove();
					ex.loadExtraLargeImage( $hero );

				}, 800 );

			};

			removeHero = function() {

				$sourceImage.remove();
				$largeImage.attr({ src: notFoundImage });

				LC.warn( "broken hero image, removing: " + resolution );

			};

			// start showing the spinner
			LC.pdp.hero.showSpinner( $hero );

			// start loading the image.
			img.onload = showHero;
			img.onerror = removeHero;
			img.src = resolution;

			// test for cache, if the image exists in
			// cache, then set a small delay so we get a smooth
			// animation, and not a flashing image, also we
			// artificially increase the speed of the animation.
			if ( img.complete ||
				img.width + img.height > 0 ) {

				$sourceImage.css({
					"-webkit-transition-duration": "300ms",
					"-moz-transition-duration": "300ms",
					"-ms-transition-duration": "300ms",
					"transition-duration": "300ms"
				});

				spinnerDelay = 10;

			}

		};

		/**
		 * main method for loading a hero image, just provide a hero
		 * wrapper ( .hero-image ) and it will do a beautiful loading visual
		 * by placing a new, hidden image on top and then fading it in when
		 * loaded
		 *
		 * @param  { $el } $hero | jQuery object with a single hero container
		 */
		ex.loadExtraLargeImage = function( $hero ) {

			// error handling, don't try to load a non-existant image.
			if ( typeof $hero === "undefined" || !$hero.length ) {

				LC.warn( "tried to run ex.loadExtraLargeImage without a `$hero`" );
				return;

			}

			var $sourceImage = $hero.children(".hero-image__img"),
				resolution = $hero.data( "res-xl" ),
				notFoundImage = LC.config.getValue("url.productImageNotFound-xl"),
				img = new Image(),
				showHero,
				removeHero;

			// leave the method if it's already the correct
			// image loaded.
			if ( $sourceImage.attr("src") === resolution ) {
				return;
			}

			// method to handle showing the hero nicely
			showHero = function() {

				// change the source for the new image
				$sourceImage.attr({ src: resolution });

			};

			removeHero = function() {

				$sourceImage.attr({ src: notFoundImage });
				LC.warn( "broken hero image, removing: " + resolution );

			};

			// start loading the image.
			img.onload = showHero;
			img.onerror = removeHero;
			img.src = resolution;

		};

		/**
		 * create a UI "hero" from a handlebars template which we can add to the UI
		 *
		 * @param  {object} image 	| a single image object with image and tooltip
		 * @return {html}        	| returns a html string
		 */
		_this.createHero = function( key, image, essentialInfo ) {

			var template;

			image.tiny = 	image.image;
			image.large = 	LC.format.productImage( image.image, "l" );
			image.huge = 	LC.format.productImage( image.image, "xl" );

			image.class = ( key === 0 ) ? "" : "hide";

			template = Handlebars.compile( _this.$heroTemplate.html() );

			return template({

				imageTiny: image.tiny,
				imageLarge: image.large,
				imageHuge: image.huge,
				imgTitle: image.tooltip,
				brandName: essentialInfo.brandName,
				productName: essentialInfo.displayName,
				imageClass: image.class

			});

		};

		/**
		 * Return an array with the images ordered as
		 * desired, based on the data attribute set in the JSP file.
		 * takes a list of thumbs from teh ATG response
		 *
		 * @param  { Object } thumbs   | thumbs object form ATG response
		 * @param  { Object } tooltips | tooltips object from ATG response
		 * @return { Array }           | array of objects containing images/thumbs
		 *
		 */
		_this.getOrderedImages = function( thumbs, tooltips ) {

			if ( typeof thumbs === "undefined" ) {
				return false;
			}

			var tempArr = [],
				tempObj,
				i = 0,
				order = _this.$heroTemplate.data("order");

			// split the order data string so we can loop through it.
			order = order.replace(/\s/gi, "").split(",");

			while ( i < _.size( order ) ) {

				if ( typeof thumbs[ order[ i ] ] !== "undefined" ) {

					tempObj = {
						image: thumbs[ order[ i ] ],
						tooltip: tooltips[ order[ i ] ]
					};

					tempArr[ tempArr.length ] = tempObj;

				}

				i++;

			}

			return tempArr;

		};

		/**
		 * loop through all the images, and update the
		 * ui with the new options available
		 * @param  {object} images | atgResponse.essentialInfo
		 */
		_this.rebuild = function( essentialInfo ) {

			var images = essentialInfo.thumbnails.xs,
				tooltips = essentialInfo.thumbnails.tips,
				html = "";

			images = _this.getOrderedImages( images, tooltips );

			// if there's no images for this product, then we
			// need to show the "coming soon" image which should
			// be returned in the "heroImage" property.
			//
			// The "XL" version is super large and not no brand
			// for now, so we will show hte "L" version instead.

			if ( !_.size( images ) ) {

				images = [{
					image: LC.format.productImage( essentialInfo.heroImage, "l" ),
					tooltip: Lang[ "pdpV2.product.comingSoon" ]
				}];

				LC.warn( "No hero images returned from ATG, showing coming-soon hero." );

			}

			$.each( images, function( key, image ) {

				html += _this.createHero( key, image, essentialInfo );

			});

			_this.append( html.trim() );
			ex.loadHeros();

		};

		/**
		 * refresh the UI only if the response data product id was
		 * different to the original data and also different
		 * to the previous response.
		 */
		ex.refresh = function( data ) {

			var response = data.response,
				essentialInfo = response.atgResponse.essentialInfo;

			ex.destroyCarousel();
			_this.rebuild( essentialInfo );

			// timeout to avoid carousel rendering on the same
			// frame as it's appended to DOM causing weird size
			// issues.
			requestAnimationFrame( function() {

				// always refresh carousel at 0 index
				ex.initCarousel(0);
				ex.singleHeroEvents();

			});

		};

		// return the carousel instance for Flickity, we use this
		// instead of the default jQuery method ( $carousel.flickity() )
		// because iOS had some funky issue with it, that I couldn't debug.
		_this.getCarouselInstance = function() {

			return Flickity.data( _this.$carousel[ 0 ] );

		};

		/**
		 * Return the currently selected index of the hero carousel
		 * @return { Number } | Index
		 */
		_this.getCarouselIndex = function() {

			var flkty = _this.getCarouselInstance();
			return flkty.selectedIndex;

		};

		/**
		 * Get the current index from the query-string
		 * in the URL which is defined with "fragmentKey".
		 *
		 * @return { Number/undefined } | The index, if it exists.
		 */
		_this.getCarouselQueryIndex = function() {

			var index = new URI().query(true)[ ex.fragmentKey ];
			return parseInt( index, 10 ) || undefined;

		};

		/**
		 * Get the current index from the fragment of the URL
		 * which is defined with "fragmentKey" ... this is in the format
		 * of: #?fragmentKey=n
		 *
		 * @return { Number/Undefined } | The index, if it exists.
		 */
		_this.getCarouselFragmentIndex = function() {

			var index = URI( new URI().fragment() ).query(true)[ ex.fragmentKey ];
			return parseInt( index, 10 ) || undefined;

		};

		/**
		 * Set the fragment in the URL to be the given
		 * index parameter. This will also wipe out any
		 * existing fragments as the URI library is kind of
		 * weak when dealing with fragments.
		 *
		 * Also update the URL without creating a new history state.
		 *
		 * @param { Number } index | the index we want to set
		 */
		_this.setCarouselFragmentIndex = function( index ) {

			if ( typeof index !== "undefined" ) {

				var url = new URI().fragment("").addFragment( ex.fragmentKey, index );
				history.replaceState( null, null, url.toString() );

			}

		};

		/**
		 * Remove any URL fragments and update the current
		 * URL location without changing any history states
		 */
		_this.removeCarouselFragmentIndex = function() {

			var url = new URI().fragment("");
			history.replaceState( null, null, url.toString() );

		};

		/**
		 * Initialise the carousel part of the hero image with selected slides.
		 * We have a "query" index, and a "fragment" index.
		 *
		 * Query index can be set on the JSP and will give a lovely animated
		 * load to the correct slide. The "delayedIndex" will wait until
		 * that lovely load animation has finished, then switch slides smoothly.
		 *
		 * @param  { index } index | Initial index of the carousel to display
		 *
		 */
		ex.initCarousel = function( index ) {

			var selectedIndex = _this.selectedIndex,
				delayedIndex = _this.delayedIndex,
				$images = _this.$carousel.find(".hero-image"),
				$imgs = $images.first().find("img"),
				inner = "<a />";

			if ( typeof index !== "undefined" ) {
				selectedIndex = index;
				delayedIndex = index;
			}

			_this.carouselInitialised = false;

			// only initialise the carousel
			// if there's more than one image!
			if ( _.size( $images ) > 1 ) {

				Foundation.onImagesLoaded( $imgs, function() {

					$images.removeClass( ex.hiddenClass + " " + ex.selectedClass );

					// initialise Flickity, with the index from
					// the URL query-string ( if possible )
					_this.$carousel
						.flickity({
							cellSelector: ".hero-image",
							initialIndex: selectedIndex || 0,
							cellAlign: "center",
							percentPosition: false
						});

					// add an inner item for the dots, as they are
					// quite small, and hard to click without an inner
					// element and some padding.
					_this.$carousel
						.find(".dot")
						.append( inner );

					_this.carouselInitialised = true;

					// after the carousel is loaded, we will set the
					// index to the one set in the hashFragment ( if possible )
					if ( typeof delayedIndex !== "undefined" ) {
						ex.selectHero( delayedIndex );
					}

				});

			} else {

				// try to load the extra-large image on desktop/tablet
				// if there's only a single image to show
				ex.loadExtraLargeImage( $images.first() );

			}

		};

		/**
		 * Method for going to a specific index slide,
		 * will also set the URL hash fragment for sharing use
		 *
		 * @param  { Number } index | index to go to
		 *
		 */
		ex.selectHero = function( index ) {

			if ( _this.carouselInitialised ) {

				index = index || 0;

				var flkty = _this.getCarouselInstance();
				flkty.select( index );

				// only set the carousel fragment in URL if it's
				// greater than 0, otherwise remove it.
				if ( index ) {
					_this.setCarouselFragmentIndex( index );
				} else {
					_this.removeCarouselFragmentIndex();
				}

				// trigger the setImage event;
				// the "not" parameter is very important, otherwise
				// we will have infinite loops.
				LC.pubsub.trigger("pdp.setImage", {
					index: index,
					not: "hero"
				});

			}

		};

		ex.destroyCarousel = function() {

			if ( _this.carouselInitialised ) {

				_this.$carousel
					.flickity("destroy")
					.find(".hero-image")
					.addClass( ex.selectedClass )
					.not(":first")
					.addClass( ex.hiddenClass );

				_this.carouselInitialised = false;

			}

		};

		ex.events = function() {

			_this.$carousel
				.off( "click.pdphero" )
				.off( "cellSelect.flickity" )
				.off( "staticClick.flickity" );

			_this.$carousel.on( "cellSelect.flickity", function() {

				var index = _this.getCarouselIndex(),
					$hero = _this.$container.find(".hero-image").eq(index);

				// only set the carousel fragment in URL if it's
				// greater than 0, otherwise remove it.
				if ( index ) {
					_this.setCarouselFragmentIndex( index );
				} else {
					_this.removeCarouselFragmentIndex();
				}

				// trigger the setImage event;
				// the "not" parameter is very important, otherwise
				// we will have infinite loops.
				LC.pubsub.trigger("pdp.setImage", {
					index: index,
					not: "hero"
				});

				// run the "changeSlide" event only if the
				// user is viewing a new slide index.
				if ( index !== _this.lastIndex ) {

					LC.pubsub.trigger("pdp.changeSlide", {
						index: index
					});

					_this.lastIndex = index;

				}

				ex.loadExtraLargeImage( $hero );

			});

			_this.$carousel.on( "click.pdphero", ".flickity-prev-next-button", function() {

				// track the pressing of hte next /
				// previous arrows on carousel
				var className =
					this.className
						.replace("flickity-prev-next-button", "")
						.replace("is-disabled", "");

				LC.pubsub.trigger("pdp.clickArrow", {
					which: className
				});

			});

			_this.$carousel.on( "click.pdphero", ".dot", function() {

				// track the clicking of dots on
				// the carousel
				var index = $(this).index();

				LC.pubsub.trigger("pdp.clickDot", {
					index: index
				});

			});

			_this.$carousel
				.on("staticClick.flickity", function( e, p, el, index ) {

					/**
					 * Try to get the image index, and part of the
					 * image which was clicked to feed it through to
					 * the hero-popup module, this will eventually allow us
					 * to pop up the hero at the correct location.
					 */
					var $el = $( el ),
						imageXlUrl = $el.data("resXl"),
						flkty = _this.getCarouselInstance(),
						touch = e.originalEvent.changedTouches,
						offset = e.originalEvent.offsetY,
						ratio = 0.6;

					if ( index === flkty.selectedIndex ||
							typeof flkty.selectedIndex === "undefined" ) {

						if ( touch ) {

							// if we detect the event has touch-properties, then
							// we switch the offset to use the touch properties to
							// determine the clicked part of the image
							offset = touch[ 0 ].pageY - $el.dimensions().offset.top;

						}

						if ( offset ) {

							// ratio is the decimal-representation of the part
							// of the image we want to focus at the center of the
							// screen.
							ratio = parseFloat(( offset / $el.height()).toFixed(3));

						}

						// if the image we clicked is the active image, then
						// load the hero popup modal via pubsub.

						LC.pubsub.trigger( "pdp.openHeroModal", {
							index: index,
							imageCenter: ratio,
							imageXlUrl: imageXlUrl
						});

					} else {

						// otherwise, scroll the carousel to the image we clicked.

						ex.selectHero( index );

					}

				});

		};

		// events to bind only when there's a single hero image.
		ex.singleHeroEvents = function() {

			var $images = _this.$carousel.find(".hero-image");

			// only apply event handler to the hero image
			// for loading hte popup if the amount of images
			// is exactly 1. Becuase we will use the carousel event above
			// to handle the event when a carousel has loaded.

			if ( _.size( $images ) === 1 ) {

				$images
					.off(".pdphero")
					.checkmove()
					.on("click.pdphero touchend.pdphero", function(e) {

						if ( !$(this).data("touchmoved") ) {

							e.preventDefault();

							/**
							 * Try to get the image index, and part of the
							 * image which was clicked to feed it through to
							 * the hero-popup module, this will eventually allow us
							 * to pop up the hero at the correct location.
							 */
							var $el = $( this ),
								imageXlUrl = $el.data("resXl"),
								touch = e.originalEvent.changedTouches,
								offset = e.originalEvent.offsetY,
								ratio = 0.6;

							if ( touch ) {

								// if we detect the event has touch-properties, then
								// we switch the offset to use the touch properties to
								// determine the clicked part of the image
								offset = touch[ 0 ].pageY - $el.dimensions().offset.top;

							}

							if ( offset ) {

								// ratio is the decimal-representation of the part
								// of the image we want to focus at the center of the
								// screen.
								ratio = parseFloat(( offset / $el.height()).toFixed(3));

							}

							// if the image we clicked is the active image, then
							// load the hero popup modal via pubsub.

							LC.pubsub.trigger( "pdp.openHeroModal", {
								index: 0,
								imageCenter: ratio,
								imageXlUrl: imageXlUrl
							});

						}

					});

			}


		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("hero") && data.isDifferent ) {
					ex.refresh( data );
				}
			});

			LC.pubsub.on( "pdp.setImage", function( e, data ) {
				if ( data && data.index >= 0 ) {
					if ( !data.not || !data.not.includes("hero") ) {
						ex.selectHero( data.index );
					}
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> needHelp
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.needHelp = lcmodule( function( exports ) {

		exports.moduleName = "pdp.needHelp";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		/**
		 * initialise the needHelp module
		 */

		ex.init = function() {

			_this.$emailLink = $(".desktop-needhelp__email, .mobile-needhelp__email");
			_this.$callUsLink = $(".mobile-needhelp__phone");

			ex.events();

		};

		ex.sendEmail = function() {

			var url = new URI().toString(),

				emailAddress = LC.config.getValue( "site.customerCareEmailAddress" ),
				data = $(".product-title").data(),
				productName = encodeURIComponent( data.productName ),
				brandName = encodeURIComponent( data.brandName ),

				subject = brandName + "%20%7C%20" + productName,
				lineBreakCharacter = "%0A%0A",
				body = "",
				final;

			// wechat, or lcApp, both do not accept
			// line breaks in their content, so we need
			// to prevent that.
			if (
				LC.helpers.isLcApp() ||
				LC.helpers.isWeChat()
			) {
				lineBreakCharacter = "";
			}

			// Encode the url for the email body except in-app browser
			// as it does not support URLEncoding
			if ( LC.helpers.isLcApp() !== true ) {
				url = encodeURIComponent( url );
			}

			// try to add some spaces before the content of the email
			// so the user can fill in their own content before
			body = lineBreakCharacter + url;


			// final email link string
			final = "mailto:" + emailAddress + "?subject=" + subject + "&body=" + body;

			// open the mail link
			LC.location.href = final;

		};

		ex.events = function() {

			_this.$emailLink.on( "click.pdphelp", function( e ) {

				e.preventDefault();

				LC.track.trigger("ga.event", {
					category: "pdp need help",
					action: "clicked button",
					label: "email us"
				});

				ex.sendEmail();

			});

			_this.$callUsLink.on( "click.pdphelp", function() {

				LC.track.trigger("ga.event", {
					category: "pdp need help",
					action: "clicked button",
					label: "call us"
				});

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> price
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.price = lcmodule( function( exports ) {

		exports.moduleName = "pdp.price";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the price module
		 */
		ex.init = function() {

			_this.$pricing = 		$(".product-pricing");
			_this.$template = 		$("#tmpl-price");

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();
			_this.pricedata = $("#pricedata").data();
			_this.staffUser = LC.config.getValue("profile.isStaffUser");

			ex.subscribe();

		};

		/**
		 * small method for correctly appending the
		 * new html template to the UI
		 */
		_this.append = function( html ) {

			_this.$pricing
				.empty()
				.html( html );

		};

		/**
		 * return a nice HTML template with the correct
		 * placeholders substituted for actual data.
		 */
		_this.createPrices = function( response ) {

			var priceInfo = response.priceInfo,
				original = priceInfo.listPirce,
				current = priceInfo.productPrice,
				onSale = priceInfo.isProductOnSale,
				save  = priceInfo.savePercentage,
				tax = priceInfo.taxMessage,

				comingSoon = response.productStatus.includes( "comingSoon" ),
				additionalMessage = priceInfo.additionalMessage,
				noStaffDiscount = priceInfo.dialogContentFragmentId !== "",
				fixed = "",

				template = Handlebars.compile( _this.$template.html() );

			if ( priceInfo.isPriceControl ) {
				fixed = priceInfo.priceControlMessage;
			}

			return template({

				originalPrice: original,
				currentPrice: current,
				fixedPrice: fixed,

				showDiscountedPrice: onSale,
				hasDiscountPercent: save,
				finalDiscountPercent: save,
				txtTaxDisplay: tax,
				noStaffDiscount: noStaffDiscount,

				comingSoon: comingSoon,
				additionalMessage: additionalMessage

			});

		};

		/**
		 * take the essential info from the API, and then
		 * update the UI with each part needed.
		 */
		_this.rebuild = function( response ) {

			var html = _this.createPrices( response );

			_this.append( html );

			// bind help icon for anything like fixed price message
			LC.pubsub.trigger("bindHelpicons");

		};

		/**
		 * refresh the UI only if the response data was
		 * different to the original data and also different
		 * to the previous response.
		 */
		ex.refresh = function( data ) {

			var response = data.response;

			_this.rebuild( response.atgResponse );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("price") && data.isDifferent ) {
					ex.refresh( data );
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> productInfo
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.productInfo = lcmodule( function( exports ) {

		exports.moduleName = "pdp.productInfo";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		/**
		 * boolean used to prevent the accordion event
		 * from firing on the first page load. This is because
		 * zurb always fires a "open" event for the accordion when
		 * the widget initialise.
		 * @type {Boolean}
		 */
		_this.initialEvent = true;

		/**
		 * initialise the productInfo module
		 */
		ex.init = function() {

			// this is not a jQuery reference because
			// we need to re-initialise the container each time
			// we place new content in there.
			_this.container = ".product-info";

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();
			ex.subscribe();

		};

		/**
		 * replace the current info with the new one.
		 * and reinitialise the foundation plugins.
		 */
		_this.replaceInfo = function( html ) {

			$( _this.container ).replaceWith( html );
			Foundation.Tooltip.cleanup();
			$( _this.container ).foundation();

		};

		_this.getInfo = function( data ) {

			var productId = data.essentialInfo.productId;

			/**
			 * kill the existing ajax call
			 */
			if ( typeof _this.ajax !== "undefined" ) {
				_this.ajax.abort();
			}

			_this.ajax = $.ajax({

				url: "/product/include/sections/product-info.jsp",
				type: "POST",
				cache: false,
				data: {
					productId: productId
				}

			})

				.done( function( response ) {

					_this.replaceInfo( response );

				})

				.fail( function( xhr, status ) {

					LC.info( "product info ajax call failed: " + status );

				});

		};


		/**
		 * take the essential info from the API, and then
		 * update the UI with each part needed.
		 */
		_this.rebuild = function( data ) {

			_this.getInfo( data );

		};

		/**
		 * refresh the UI only if the response data was
		 * different to the original data and also different
		 * to the previous response.
		 */
		ex.refresh = function( data ) {

			var response = data.response;

			_this.rebuild( response.atgResponse );

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("productinfo") && data.isDifferent ) {
					ex.refresh( data );
				}
			});

			$( _this.container ).on("change.zf.tabs", function() {

				var tab =
					$( _this.container )
						.find(".lc-tabs .is-active")
						.text()
						.trim();

				LC.pubsub.trigger("pdp.openInformationTab", { name: tab });

			});

			$( _this.container ).on("down.zf.accordion", function() {

				// run the "openInformationAccordion" event only if the
				// user is viewing a new slide index.
				if ( !_this.initialEvent ) {

					var tab =
						$( _this.container )
							.find(".lc-accordion .is-active a")
							.text()
							.trim();

					LC.pubsub.trigger("pdp.openInformationAccordion", { name: tab });

				} else {

					_this.initialEvent = false;

				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> quantity
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.quantity = lcmodule( function( exports ) {

		exports.moduleName = "pdp.quantity";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		_this.max = 5;
		_this.min = 1;
		_this.show = true;
		_this.inventory = 0;



		/**
		 * initialise the quantity module
		 */
		ex.init = function() {

			_this.$quantity = 		$(".product-quantity-picker");
			_this.$input = 			$(".product-quantity__value");

			// get initial data
			_this.qtydata = $("#qtydata").data();

			_this.show = _this.qtydata.show;
			_this.inventory = _this.qtydata.stock;
			_this.purchaseLimit = _this.qtydata.purchaseLimit;
			_this.max = _this.qtydata.max;

			ex.handleZeroStock();
			ex.activateWidget();
			ex.setVisible();
			ex.subscribe();

		};

		/**
		 * reinitialise the quantity picker widget
		 * if a size was recalled from localStorage
		 * @param   {Integer}  stock  the stock of the recalled size
		 */
		ex.reinit = function( stock ) {

			_this.qtydata.stock = stock;
			_this.inventory = stock;
			_this.min = 1;
			_this.max = _this.qtydata.max;
			_this.show = _this.qtydata.status === "normal" && _this.qtydata.max > 1;

			ex.handleZeroStock();
			ex.activateWidget();
			ex.setVisible();

		};

		/**
		 * do a special handling when the stock is at 0,
		 * we basically just update the local state for min/max
		 */
		ex.handleZeroStock = function() {

			// handle a scenario where stock can be 0,
			// usually the quantity picker will be hidden, as well
			if ( _this.qtydata.stock <= 0 ) {
				_this.max = 0;
				_this.min = 0;
			}

		};

		/**
		 * should we activate the widget's component
		 * depending on whether it exists in DOM or not
		 */
		ex.activateWidget = function() {

			if ( _this.$quantity.length ) {

				// save the quantity widget instance for future use
				_this.widget = _this.$quantity.lcQuantitySelect().data().lcQuantitySelect;
				_this.widget.setMin( _this.min );
				_this.widget.setMax( _this.max );

			}

		};

		ex.setVisible = function() {

			if ( _this.show && _this.inventory > 1 ) {

				ex.show();

			} else {

				ex.hide();

			}

		};

		ex.hide = function() {

			_this.$quantity.addClass( ex.hiddenClass );

		};

		ex.show = function() {

			_this.$quantity.removeClass( ex.hiddenClass );

		};

		/**
		 * refresh the user interface, with the new atg response
		 * @param  {object} data | atgResponse
		 */
		ex.refresh = function( data ) {

			var response = data.response.atgResponse,
				max = _this.max = parseInt( response.quantityWidgetInfo.max, 10 ),
				remainingPurchaseLimit = response.quantityWidgetInfo.purchaseLimit;

			_this.inventory = parseInt( response.inventory, 10 );
			_this.purchaseLimit = _this.inventory;

			if ( remainingPurchaseLimit !== null ) {
				_this.purchaseLimit = remainingPurchaseLimit;
			}

			_this.max = ( max < _this.purchaseLimit ) ? max : _this.purchaseLimit;
			_this.min = ( _this.max > 0 ) ? 1 : 0;
			_this.show = response.quantityWidgetInfo.showQtyWidget !== "none" && _this.max > 1;

			ex.activateWidget();
			ex.setVisible();

		};

		ex.subscribe = function() {

			/**
			 * refresh the quantity picker with the
			 * atg response whenever the color/size is
			 * updated.
			 */
			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("quantity") ) {
					ex.refresh( data );
				}
			});

			/**
			 * if a size was recalled from the sizepicker widget during
			 * page load, then there's a chance the stock/inventory levels of
			 * the "defaultSizeSku" are different to the recalled
			 * product size, and so we need to re-initialize the
			 * quantity picker with the recalled size's inventory.
			 */
			LC.pubsub.on( "pdp.initSizeSelect", function( e, data ) {
				ex.reinit( data.stock || 0 );
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> sizeguide
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.sizeguide = lcmodule( function( exports ) {

		exports.moduleName = "pdp.sizeguide";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		/**
		 * initialise the sizeguide module
		 */

		ex.init = function() {

			// initialisation code
			ex.subscribe();

		};

		/**
		 * Update all size guide link including size guide links renderred after initial load
		 */

		_this.getAllSizeGuideLinks = function() {
			return $(".js-size-chart");
		};

		/**
		 * Update size guide link(s)
		 */

		ex.updateLinks = function(productId, skuId) {

			if ( productId !== "" ) {

				var $links = _this.getAllSizeGuideLinks(),
					productLink = "/product/productSizeGuide.jsp?productid=" +
									productId + "&skuid=" + skuId;

				$links
					.attr("href", productLink)
					.data("url", productLink)
					.data("productid", productId)
					.data("skuid", skuId);

			}

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function(e, data) {

				if ( typeof data.response.atgResponse !== "undefined" ) {

					var productId = data.response.atgResponse.essentialInfo.productId,
						skuId = data.response.requestData.skuId;

					if ( productId !== "" ) {

						ex.updateLinks(productId, skuId);

					}

				}

			});

			LC.pubsub.on( "pdp.initSizeSelect", function(e, data) {

				var skuId = data.skuId,
					productId = LC.helpers.productFromSku( skuId );

				if ( productId !== "" ) {

					ex.updateLinks(productId, skuId);

				}

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> sizepicker
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.sizepicker = lcmodule( function( exports ) {

		exports.moduleName = "pdp.sizepicker";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};


		/**
		 * initialise the sizepicker module
		 */
		ex.init = function() {

			_this.$productSizes = $("#product-sizes");
			_this.$sizelist = $("#sizepicker__select");
			_this.$selectTemplate = $("#tmpl-sizeoption");

			_this.$conversion = $(".lc-conversion");

			_this.label = "lc-label";
			_this.labelActive = _this.label + "--active";
			_this.labelDisabled = _this.label + "--disabled";

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();
			_this.qtydata = $( "#qtydata" ).data();

			_this.initLayout();
			_this.initSelected();
			_this.initConversion();

			ex.events();
			ex.subscribe();

		};

		_this.initLayout = function() {

			ex.displayWidget();

		};

		/**
		 * Method to display the widget when the page loads.
		 * This is because the swatch-stacking causes a
		 * flash-of-unstyled-colors, so we make it hidden
		 * in the JSP, then fade it in after stacking.
		 */
		ex.displayWidget = function() {

			_this.$productSizes.removeClass("opc-0");

		};

		_this.initConversion = function() {

			// don't initialise if there's no conversion
			// widget in the viewport!
			if ( !_this.$conversion.length ) {
				return;
			}

			ex.convert( undefined );

		};

		/**
		 * set the initial selection attributes based on:
		 * - product has size-labels (-*)
		 * - is there only one size
		 * - product default SKU has inventory.
		 * - we previously saved this size
		 * 	 - and it's in stock
		 */
		_this.initSelected = function() {

			_this.selected = "";

			var id = 				_this.pdpdata.productId,
				$sizes = 			_this.$sizelist.find( "option" ),
				sizes = 			$sizes.map( function() { return $(this).data(); }),
				defaultSku = 		_this.pdpdata.defaultsizesku,
				starSizes = 		LC.helpers.isStarSku( defaultSku ),
				querySize = 		_this.querySize(),

				sizesWithInventory =
					_.filter( sizes, function( item ) {
						return item.stock >= 1;
					});

			// if the sizes are label sizes, and not real sizes; we
			// need to select the defaultSku...
			if ( starSizes ) {

				_this.selected = _this.pdpdata.defaultsizesku;

			// if there's only one size that has a inventory,
			// then we will always select that one.
			} else if ( sizesWithInventory.length === 1 ) {

				_this.selected = sizesWithInventory[ 0 ].skuid;


			// if there was a size provided in the query string
			// parameter, then we will set it to that query string.
			} else if ( querySize ) {

				_this.selected = querySize;

			// if we haven't selected a default sku above, then we
			// finally try to recall the last size the user selected
			// on a previous visit to the page.
			} else {

				_this.selected = _this.recallSize( id );

			}

			// store the skuid state. This only
			// needs to happen on Init, because it is
			// always updated in the LC.pdp.general (ajax) update.
			_this.pdpdata.skuId = _this.selected;

			ex.setSelected();

			/**
			 * fire an event to tell the UI we just
			 * selected the size during initialization
			 * ( mostly used for delivery promise / wishlist )
			 *
			 * it requires a short timeout to make sure all other
			 * modules have had time to register listeners to this
			 * event during initialisation.
			 */

			setTimeout( function() {

				var $selectedSize = ex.getSelected();

				if ( !$selectedSize.is( "#sizedefault" ) ) {

					LC.pubsub.trigger("pdp.initSizeSelect", {
						skuId: _this.pdpdata.skuId,
						stock: $selectedSize.data( "stock" ) || 0,
						available: $selectedSize.data( "available" )
					});

				}

				LC.pubsub.trigger( "pdp.initViewProduct", _this.pdpdata.skuId || id );

			}, 200);

		};

		/**
		 * dispatch both selections, if passed
		 * a SKU, then update to that.
		 *
		 * @param {String} sku | SKU to set as selected.
		 */
		ex.setSelected = function( sku ) {

			if ( sku && LC.helpers.isSku( sku ) ) {

				_this.selected = sku;

			}

			var $select = _this.$sizelist,
				$options = $select.find( "option" ),
				$selected = $options.filter( "[ value = '" + _this.selected + "' ]" );

			// set the sku as default sku if the inputed sku are not find in DOM
			if ( !$selected.length ) {

				$selected = $select.find(  "#sizedefault" );
				_this.selected = $selected.val();

			}

			// set the value to the correct item
			$select.val( _this.selected );

			// update the placeholder / label style
			_this.refreshListLabel();

		};

		/**
		 * return the input that is selected.
		 */
		ex.getSelected = function() {

			return _this.$sizelist.find( "option:selected" );

		};

		/**
		 * tiny method to refresh the label on the sizelist
		 * (used when updating the items in list)
		 */
		_this.refreshListLabel = function() {

			// update the placeholder / label style
			_this.$sizelist.trigger( "update.lcSelects" );

		};

		/**
		 * return the index of the selected
		 * color in the sizelist, removing the
		 * breakers from the equation.
		 *
		 * @return { Integeter } | the index of the selected color, or 0.
		 */
		ex.getSelectedIndex = function() {

			var $selected = ex.getSelected(),
				index = $selected.index();

			if ( index < 0 ) {
				index = 0;
			}

			return index;

		};

		/**
		 * decide whether to display the whole conversion wiget, or not.
		 * @param { object } response | atgResponse
		 */
		ex.setState = function( response ) {

			var visible = LC.pdp.general.showSizeWidget( response );

			/**
			 * toggle the hidden class
			 */
			_this.$productSizes
				.toggleClass( ex.hiddenClass, !visible );

		};

		/**
		 * small method for correctly appending the
		 * new html template to the UI
		 */
		_this.append = function( html ) {

			var $select = _this.$sizelist,
				$default = $select.find("#sizedefault"),
				$others = $select.find("option").not( $default );

			$others.remove();
			$select.append( html );

		};

		/**
		 * create a <option> from a handlebars template
		 * which we can add to the UI <select>
		 *
		 * @param  {object} size 			| a single size-label object from atg.response
		 * @param  {boolean} forceSelect 	| whether to force it as selected.
		 * @return {html}        			| returns a html string
		 */
		_this.createOption = function( size, forceSelect ) {

			var stateAttr = "",
				template,
				mockData = false,
				available = true;

			/**
			 * if a size returns as "mockData" it means that it is
			 * just a placeholder and has no stock, so we just
			 * combine "mockData" and Size to create a unique
			 * identifier for the size option, this has no logical use, just
			 * ui sanitation.
			 */
			if ( size.skuId === "" || size.skuId === "mockData" ) {

				size.skuId = "mockData-" + size.size;
				mockData = true;

			}

			if ( mockData ||
				size.hasStock === false ||
				size.publicationStatus === "Unpublished" ) {

				available = false;

			}

			if ( mockData ) {

				stateAttr = "disabled";

			}

			if ( size.skuId === _this.selected ) {

				stateAttr = "selected";

			}

			if ( forceSelect ) {

				stateAttr = "selected";

			}

			template = Handlebars.compile( _this.$selectTemplate.html() );

			return template({

				size: size.size,
				txtSize: size.size,
				hasStock: size.hasStock,
				productUrl: size.productUrl,
				skuId: size.skuId,
				productId: size.productId,
				stateAttr: stateAttr,
				available: available

			});

		};

		/**
		 * loop through all the sizes, and update the
		 * ui with the new options available
		 *
		 * @param  {object} response | atgResponse
		 */
		_this.rebuild = function( response ) {

			var sizes = response.atgResponse.sizeSwatchList,
				onlyOneSize = sizes.length === 1,
				html = "";

			if ( !sizes.length ) {
				LC.info( "no sizes returned from ATG, doing nothing." );
				return;
			}

			$.each( sizes, function( key, size ) {

				// if there's only one size, we want to auto-select it.
				html += _this.createOption( size, onlyOneSize );

			});

			_this.append( html.trim() );

			// re-convert the size picker if needed.
			ex.convert( undefined );

		};

		/**
		 * method to save the last selected size for this product
		 * so we can set it by default next time the user lands
		 * on this product.
		 *
		 * @param  {string} id 	| product id
		 * @param  {string} sku | product sku id
		 *
		 */
		_this.rememberSize = function( id, sku ) {

			var saved = LC.localStorage.getItem("savedSizes") || [],
				newSaved = saved;

			if ( id && sku ) {

				try {

					if ( sku.split("-")[ 1 ] !== "*" ) {

						if ( typeof saved === "string" ) {

							saved = JSON.parse( saved );

						}

						if ( _.find( saved, { id: id } ) ) {

							_.each( saved, function( item ) {

								if ( item.id === id ) {
									item.sku = sku;
								}

							});

						} else {

							if ( saved.length >= 30 ) {

								saved.shift();

							}

							saved.push( { id: id, sku: sku } );

						}

						newSaved = JSON.stringify( saved );
						LC.localStorage.setItem( "savedSizes", newSaved );

					}

				} catch (e) {

					LC.warn( "issue with JSON parsing or localStorage" );
					LC.error( e );
					LC.info( "flushing selected-size memory" );
					LC.localStorage.removeItem( "savedSizes" );

				}

			}

			return newSaved;

		};

		/**
		 * method to try and set the size based on a querystring
		 * from the url called "selectedSize" or "skuId"
		 */
		_this.querySize = function() {

			var sku = "",
				queries = URI.parseQuery( LC.location.search ),
				$option,
				found;

			// first try to get the size from the query-string
			// parameter if it exists
			if ( _.has( queries, "selectedSize" ) ) {

				found = queries.selectedSize;

			} else if ( _.has( queries, "skuId" ) ) {

				found = queries.skuId;

			}

			// check the size that is returned
			// has some inventory, and then return that size
			if ( found ) {

				$option = _this.$sizelist.find( "[data-skuid='" + found + "']" );

				if ( $option.data("stock") > 0 ) {

					sku = found;

				}

			}

			return sku;

		};

		ex.getConversionData = function() {

			var data = _this.$conversion.data();
			return data;

		};

		/**
		 * Method to get the new, converted size of a given size
		 * @param  {String} country        | The country we are trying to convert to
		 * @param  {String} size           | The size we would like to convert
		 * @param  {Object} conversionData | An object with the product's original
		 *                                 | country/dimension/gender
		 * @return {String}                | The new converted size
		 */
		ex.getConvertedSize = function( country, size, conversionData ) {

			if ( typeof country === "undefined" ||
				typeof size === "undefined" ||
				typeof conversionData === "undefined" ) {

				LC.warn("Size Conversion not possible; missing data.");
				return undefined;

			}

			var key,
				convertedSize,
				convertTo = 		country,
				convertFrom = 		conversionData.country,
				convertGender = 	conversionData.gender,
				convertDimension = 	conversionData.dimension,

				fixture =
					LC.fixtures.sizeConversion.sizes[ convertGender ][ convertDimension ];

			try {

				key = fixture[ convertFrom ].from[ size ];
				convertedSize = fixture[ convertTo ].to[ key ];

			} catch ( error ) {

				LC.warn("Size Conversion failed; JSON missing the given conversion values.");
				return undefined;

			}

			return convertedSize;

		};


		/**
		 * convert the sizepicker UI to a new
		 * country code, or back to original if needed
		 *
		 * @param  { String } country 			| code of the country to convert to
		 */
		ex.convert = function( country ) {

			var $country,
				conversionData = ex.getConversionData();

			if ( _this.$conversion.length ) {

				if ( !country ) {

					// use the dropdown prototype state
					// method to get the selected item
					$country =
						_this.$conversion
							.find( ".lc-conversion__list-item.is-selected" );

					if ( $country.length ) {

						country = $country.data().value;

					}

				}

				if ( country ) {

					// just a debugging log to help.
					LC.log( "converting sizes from: " +
						   conversionData.country + ", to: " + country );

					_this.convert( country, conversionData );

				}

			}

		};

		/**
		 * convert the sizepicker UI to a new
		 * country code, or back to original if needed.
		 *
		 * @param  { String } country 			| code of the country to convert to
		 * @param  { Object } conversionData 	| data needed for conversion
		 */
		_this.convert = function( country, conversionData ) {

			var $sizes = _this.$sizelist.find( "option" ).not("#sizedefault"),
				labelCountry = conversionData.country;

			$sizes.each( function( k, el ) {

				var $option = $(el),
					data = $option.data(),
					newSize = ex.getConvertedSize( country, data.size, conversionData ),
					showLabelCountry = false,
					text = data.size,
					unavailable = "";

				// if the converted size is "undefined" (ie, data to
				// convert it doesn't exist), or the convert-to
				// country is the same as the convert-from country... then
				// we probably would like to just show the default
				// label-country's size, to prevent errors in the UI.
				if ( country === labelCountry || typeof newSize === "undefined" ) {
					showLabelCountry = true;
				}

				// unavailability needs to be checked by
				// referencing the option's data attribute. we
				// should show a message in this scenario.
				if ( data.available === false ) {

					unavailable =
						" - " + Lang[ "productDetails.selectYourSize.option.notInStock.text" ];

				}

				// if we are just going to show the default
				// label country, then just set the text to
				// the default size, and put the "unavailable" string
				// inside of a greyed out span.
				if ( showLabelCountry ) {

					text =
						data.size +
						"<span class=\"txt-grey\">" +
							unavailable +
						"</span>";

				// but if we are going to convert, then
				// we set up some elements for display purposes.
				} else {

					// if the label country is S/M/L ... then
					// we do not show the country name.
					if ( labelCountry === "DEFAULT" ) {
						labelCountry = "";
					}

					text =
						country +
						" " +
						newSize +
						"<span class=\"txt-grey\">" +
							" / " +
							labelCountry +
							" " +
							data.size +
							unavailable +
						"</span>";

				}

				// append the new text to the options
				$option.html( text );

			});

			// update the display of the select box,
			// using the $.fn.lcSelects() api (pubsub)
			_this.$sizelist.trigger("update.lcSelects");

		};

		/**
		 * method to recall the previously selected sizes
		 * from the localStorage
		 * @param  {string} id  | product id
		 * @param  {string} sku | product sku id
		 * @return {string}     | product sku id
		 */
		_this.recallSize = function( id ) {

			var sku,
				json = LC.localStorage.getItem("savedSizes"),
				saved;

			// let's look inside the local storage to
			// try and find this product's ID.
			if ( json ) {

				try {

					json = JSON.parse( json );

				} catch ( e ) {

					LC.info( "issue with JSON parsing of remembered sizes" );
					LC.warn( e );
					LC.info( "flushing size memory" );

					LC.localStorage.removeItem("savedSizes");

				}

				saved = _.find( json, { id: id } );
				sku = ( saved ) ? saved.sku : undefined;

			}

			return sku;

		};

		/**
		 * method for programmatically changing the size
		 * @param  {string}  id  		  | Product Id
		 * @param  {string}  sku 		  | Product Sku
		 * @param  {boolean} forceRefresh | should we force a refresh on the swatch stack
		 */
		ex.change = function( id, sku, forceRefresh ) {

			LC.info( "changing size..." );
			LC.info( arguments );

			// if the id/sku are invalid or missing, then
			// the selected size should be undefined.
			if ( !id || !LC.helpers.isProduct( id ) ||
			    !sku || !LC.helpers.isSku( sku ) ) {

				LC.warn( "...changing size failed due to invalid id / sku" );
				_this.selected = undefined;

			} else {

				_this.selected = sku;

			}

			ex.setSelected();

			_this.rememberSize( id, sku );

			LC.pubsub.trigger( "pdp.chooseSize", {

				skuId: sku,
				productId: id,
				not: "size",
				forceRefresh: forceRefresh

			});

		};

		/**
		 * refresh the user interface, with the new atg response
		 * @param  {object} data | atgResponse
		 */
		ex.refresh = function( data ) {

			var response = data.response,
				productId,
				recalledSize,
				$recalledSize;

			ex.setState( response );
			_this.rebuild( response );

			productId = response.atgResponse.essentialInfo.productId;
			recalledSize = _this.recallSize( productId );

			if ( recalledSize ) {

				// check the size that is returned
				// has some inventory, and then select that size

				$recalledSize = _this.$sizelist.find("[ data-skuid='" + recalledSize + "' ]");

				if ( $recalledSize.data("stock") > 0 ) {

					ex.setSelected( recalledSize );

				}

			} else {

				_this.refreshListLabel();

			}

		};

		ex.events = function() {

			// unbind all events first.
			_this.$sizelist.off(".sizepicker");

			_this.$sizelist
				.on("change.sizepicker", function(e) {

					var data = $( e.target ).children(":selected").data();
					ex.change( data.id, data.skuid );

				});

		};


		ex.subscribe = function() {

			// When we change colour, we only want to keep
			// the size selected if it was a "-*", because we can't
			// actually get the size label when doing an ajax call.
			LC.pubsub.on( "pdp.chooseColor", function( e, data ) {

				_this.selected = "";

				if ( data.skuId.includes( "-*" ) ) {
					_this.selected = data.skuId;
				}

			});

			LC.pubsub.on( "pdp.update", function( e, data ) {

				if ( !data.not.includes("size") ) {

					// refresh the sizepicker if the
					// pdp ui is updated.
					ex.refresh( data );

				}

				if ( data.response.requestData.forceRefresh ) {

					// set focus to the size we just picked.
					ex.getSelected().trigger("focus");

				}

			});

			// listen for conversion calls from
			// the sizeconversion module.
			LC.pubsub.on( "pdp.convertSize", function( e, data ) {

				if ( data.country ) {
					ex.convert( data.country );
				}

			});

			LC.pubsub.on( "pdp.restackSize", ex.stackSwatches );

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> sizetype
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.sizetype = lcmodule( function( exports ) {

		exports.moduleName = "pdp.sizetype";

		// "exports"" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};

		/**
		 * initialise the sizetype module
		 */

		ex.init = function() {

			// initialisation code
			_this.$sizeType = $(".product-size-type");

			ex.events();
			ex.subscribe();

		};

		ex.show = function() {

			// show the size type label if we can
			if ( _this.$sizeType.length ) {

				_this.$sizeType.removeClass( ex.hiddenClass );
				LC.info( "📏 showing size type instead of conversion" );

			}

		};

		ex.hide = function() {

			// show the size type label if we can
			if ( _this.$sizeType.length ) {

				_this.$sizeType.addClass( ex.hiddenClass );
				LC.info( "📏 hiding size type" );

			}

		};

		ex.events = function() {

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.showsizetype", ex.show );
			LC.pubsub.on( "pdp.hidesizetype", ex.hide );

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> thumbs
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.thumbs = lcmodule( function( exports ) {

		exports.moduleName = "pdp.thumbs";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the thumbnails module
		 */
		ex.init = function() {

			_this.$container = 		$(".product-thumbnails");
			_this.$thumbTemplate = 	$("#tmpl-thumbnail");

			// get initial pdp data
			_this.pdpdata = $("#pdpdata").data();
			_this.replaceThumbs();

			ex.subscribe();
			ex.events();

		};

		/**
		 * small method for correctly appending the
		 * new html template to the UI
		 */
		_this.append = function( html ) {

			_this.$container
				.empty()
				.html( html );

		};

		/**
		 * create a UI "thumb" from a handlebars template which we can add to the UI
		 *
		 * @param  {object} image 	| a single image object with image and tooltip
		 * @return {html}        	| returns a html string
		 */
		_this.createThumb = function( key, image, essentialInfo ) {

			var template;

			image.tiny = image.image;
			image.small = image.tiny.replace("_xs", "_s");

			template = Handlebars.compile( _this.$thumbTemplate.html() );

			return template({

				imageTiny: image.tiny,
				imageSmall: image.small,
				imgTitle: image.tooltip + Lang.clickToEnlarge,
				brandName: essentialInfo.brandName,
				productName: essentialInfo.displayName

			});

		};

		_this.getOrderedImages = function( thumbs, tooltips ) {

			if ( typeof thumbs === "undefined" ) {
				return false;
			}

			var tempArr = [],
				tempObj,
				i = 0,
				order = _this.$thumbTemplate.data("order");

			// split the order data string so we can loop through it.
			order = order.replace(/\s/gi, "").split(",");

			while ( i < order.length ) {

				if ( typeof thumbs[ order[ i ] ] !== "undefined" ) {

					tempObj = {
						image: thumbs[ order[ i ] ],
						tooltip: tooltips[ order[ i ] ]
					};

					tempArr[ tempArr.length ] = tempObj;

				}

				i++;

			}

			return tempArr;

		};

		_this.replaceThumbs = function() {

			var $thumbs = _this.$container.find(".product-thumbnails__img");

			$thumbs.each(function() {

				var $thumb = $(this),
					$spinner = $thumb.siblings(".spinner"),
					data = $thumb.data(),
					img = new Image();

				img.onload = function() {

					// change the source to the small image.
					$thumb.attr( "src", data.sm );
					// remove the spinner nicely.
					$spinner.fadeOutNicely( $spinner.remove, 600 );

				};

				img.onerror = function() {

					LC.warn( "broken thumbnail image, removing the thumb: " + data.sm );

					$thumb
						.parent( ".product-thumbnails__thumb" )
						.remove();

				};

				img.src = data.sm;

			});

		};

		/**
		 * loop through all the images, and update the
		 * ui with the new options available
		 * @param  {object} images | atgResponse.essentialInfo
		 */
		_this.rebuild = function( essentialInfo ) {

			var images = essentialInfo.thumbnails.xs,
				tooltips = essentialInfo.thumbnails.tips,
				html = "";

			if ( !_.size( images ) ) {

				// just quit out of the method, we do not
				// need to show any thumbnails
				LC.warn( "No thumbnails returned from ATG, doing nothing." );
				return;

			}

			images = _this.getOrderedImages( images, tooltips );

			$.each( images, function( key, image ) {

				html += _this.createThumb( key, image, essentialInfo );

			});

			_this.append( html.trim() );

		};

		/**
		 * refresh the UI only if the response data was
		 * different to the original data and also different
		 * to the previous response.
		 */
		ex.refresh = function( data ) {

			var response = data.response,
				essentialInfo = response.atgResponse.essentialInfo;

			_this.rebuild( essentialInfo );
			_this.replaceThumbs();

		};

		/**
		 * Method for selecting a specific index thumb
		 *
		 * @param  { Number } index | index to go to
		 *
		 */
		ex.selectThumb = function( index ) {

			var $thumbs = _this.$container.find(".product-thumbnails__thumb");

			index = index || 0;

			$thumbs
				.removeClass("bor-black")
				.eq( index )
				.addClass("bor-black");

		};

		ex.events = function() {

			_this.$container
				.on( "click.pdpthumbs", ".product-thumbnails__thumb", function(e) {

					e.preventDefault();
					var index = $(this).index();

					ex.selectThumb( index );

					// trigger the setImage event;
					// the "not" parameter is very important, otherwise
					// we will have infinite loops.
					LC.pubsub.trigger("pdp.setImage", {
						index: index,
						not: "thumbs"
					});

					LC.pubsub.trigger("pdp.clickThumb", {
						index: index
					});

				});

		};

		ex.subscribe = function() {

			LC.pubsub.on( "pdp.update", function( e, data ) {
				if ( !data.not.includes("thumbs") && data.isDifferent ) {
					ex.refresh( data );
				}
			});

			LC.pubsub.on( "pdp.setImage", function( e, data ) {
				if ( data && data.index >= 0 ) {
					if ( !data.not || !data.not.includes("thumbs") ) {
						ex.selectThumb( data.index );
					}
				}
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

/**
 *
 * [ module ]
 * pdp -> tracking
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.tracking = lcmodule( function( exports ) {

		exports.moduleName = "pdp.tracking";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, exports ),
			_this = {};

		ex.init = function() {

			_this.initData();
			_this.initView();

			// store hkSalePrice for use later
			_this.hkSalePrice = _this.initHkSalePrice;

			ex.subscribe();

		};

		_this.initData = function() {

			// define the productInfo once loading the page
			_this.initLandingPage = window.trackingPageName;
			_this.initProductId = 	$("#pdpdata").data("productId");
			_this.initBrandName = 	$(".product-title__brand-name").text();
			_this.initProductName = $(".product-title__product-name").text();
			_this.initThumbnail = 	$(".product-thumbnails__img").first().attr("src");
			_this.initSalePrice = 	$("#pricedata").data("currentprice");
			_this.initHkSalePrice = $("#pricedata").data("hksaleprice");
			_this.initCategory = 	$("meta[ name = 'product-subsection1' ]").attr("content");

		};

		_this.initView = function() {

			var data = {
				thumb: 			_this.initThumbnail,
				displayName: 	_this.initProductName,
				productId: 		_this.initProductId,
				price: 			_this.initSalePrice.replace( /[^\d.-]/g, "" ),
				brandName: 		_this.initBrandName,
				categoryName: 	_this.initCategory,
				productUrl: 	_this.initLandingPage
			};

			_this.mvqPageView( data );
			_this.predictPageView( data );

		};

		_this.mvqAvailable = function() {
			return (
				typeof window._mvq !== "undefined" &&
				typeof window._mvq_AccountId !== "undefined"
			);
		};

		_this.predictAvailable = function() {
			return (
				typeof window.ScarabQueue !== "undefined"
			);
		};

		/**
		 * Method fired whenever the page refreshes from calling
		 * a new productId (size/color picker)
		 *
		 * @param  { Object } response | the atgResponse object
		 */
		ex.trackRefresh = function( response ) {

			var data = {
				thumb: 			response.essentialInfo.thumbnails.xs.indexImage,
				displayName: 	response.essentialInfo.displayName,
				productId: 		response.essentialInfo.productId,
				price: 			response.priceInfo.salePirce.replace( /[^\d.-]/g, "" ),
				brandName: 		response.essentialInfo.brandName,
				categoryName: 	_this.initCategory,
				productUrl: 	response.productUrl
			};

			_this.gaPageView( data );
			_this.mvqPageView( data );
			_this.predictPageView( data );

		};

		_this.gaPageView = function( data ) {

			LC.track.trigger("ga.pageview", {
				pageName: data.productUrl
			});


		};

		_this.mvqPageView = function( data ) {

			if ( _this.mvqAvailable() ) {

				var thumb = LC.format.productImage( data.thumb, "m" ) || "";

				_mvq.push([ "$setAccount", window._mvq_AccountId ]);
				_mvq.push([ "$setGeneral", "goodsdetail", "", "", window._mvq_vipNumber ]);
				_mvq.push([ "$logConversion" ]);

				_mvq.push([
					"$addGoods",
					data.categoryId || "",
					data.brandId || "",
					data.displayName || "",
					data.productId || "",
					data.price || "",
					thumb || "",
					data.categoryName || "",
					data.brandName || "",
					data.productStatus || "",
					data.onlinePrice || "",
					data.wishListAmount || "",
					data.productOffTime || ""
				]);

				_mvq.push([ "$logData" ]);

			}

		};

		_this.predictPageView = function( data ) {

			if ( _this.predictAvailable() ) {

				ScarabQueue.push([ "view", data.productId ]);
				ScarabQueue.push([ "category", data.categoryName ]);
				ScarabQueue.push([ "go" ]);

			}

		};

		/**
		 * Method fired whenever the "add to cart" method
		 * is triggered from PDP
		 */
		ex.trackAddToCart = function( data ) {

			LC.track.trigger( "ga.event", {
				category: "Product Page",
				action: "addToCart",
				label: data.productId
			});

		};

		/**
		 * Method fired whenever the a product is successfully added
		 * to the shopping cart from PDP
		 */
		ex.trackAddProduct = function( data ) {

			var price = parseInt( _this.hkSalePrice ) * data.quantity;

			LC.track.trigger( "ga.event", {
				category: "Shopping Bag",
				action: "Add from PDP",
				label: data.skuId
			});

			if ( _this.predictAvailable() ) {

				ScarabQueue.push([ "addToCart", data.productId, data.quantity, price ]);
				ScarabQueue.push([ "go" ]);

			}

			if ( _this.mvqAvailable() ) {

				_mvq.push([ "$setAccount", window._mvq_AccountId ]);
				_mvq.push([ "$logConversion" ]);

				_mvq.push([ "$setGeneral", "cartview", "", "", "" ]);
				_mvq.push([ "$addItem",  "", data.productId, "", "", "" ]);
				_mvq.push([ "$logData" ]);

			}

		};

		/**
		 * Method fired whenever a giftcard is successfully added
		 * to the shopping cart from PDP
		 */
		ex.trackAddGiftcard = function( data ) {

			var price = parseInt( data.giftCardAmount ) * data.quantity;

			LC.track.trigger( "ga.event", {
				category: "Shopping Bag",
				action: "Add from PDP",
				label: data.productId
			});

			if ( _this.predictAvailable() ) {

				ScarabQueue.push([ "addToCart", data.productId, data.quantity, price ]);
				ScarabQueue.push(["go"]);

			}

			if ( _this.mvqAvailable() ) {

				_mvq.push([ "$setAccount", window._mvq_AccountId ]);
				_mvq.push([ "$logConversion" ]);

				_mvq.push([ "$setGeneral", "cartview", "", "", "" ]);
				_mvq.push([ "$addItem",  "", data.productId, "", "", "" ]);
				_mvq.push([ "$logData" ]);

			}

		};

		/**
		 * Method for tracking when a slide is changed
		 * @param  { Number } index | index of slide change to
		 *
		 * Type of label is text
		 * https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
		 *
		 *
		 * nonInteraction: By default, the event hit is considered an interaction hit.
		 * The type of event hit is NOT considered an interaction hit when this value
		 * is set to true.
		*/

		ex.trackSlide = function( index ) {

			if ( typeof index !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp hero carousel",
					action: "view slide",
					label: index.toString(),
					fieldsObject: {
						nonInteraction: true
					}
				});

			}

		};

		/**
		 * Method to track clicking on arrows
		 * @param  { String } which | Which Arrow we clicked
		 *
		 * nonInteraction: By default, the event hit is considered an interaction hit.
		 * The type of event hit is NOT considered an interaction hit when this value
		 * is set to true.
		 */
		ex.trackArrow = function( which ) {

			if ( typeof which !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp hero carousel",
					action: "click arrow",
					label: which,
					fieldsObject: {
						nonInteraction: true
					}
				});

			}

		};

		/**
		 * Method for tracking when a pip/dot is pressed
		 * @param  { Number } index | index of dot
		 *
		 * Type of label is text
		 * https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
		 *
		 *
		 * nonInteraction: By default, the event hit is considered an interaction hit.
		 * The type of event hit is NOT considered an interaction hit when this value
		 * is set to true.
		 */
		ex.trackPips = function( index ) {

			if ( typeof index !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp hero carousel",
					action: "click pip",
					label: index.toString(),
					fieldsObject: {
						nonInteraction: true
					}
				});

			}

		};

		/**
		 * Method for tracking when a thumbnail is clicked
		 * @param  { Number } index | index of slide clicked
		 *
		 * nonInteraction: By default, the event hit is considered an interaction hit.
		 * The type of event hit is NOT considered an interaction hit when this value
		 * is set to true.
		 */
		ex.trackThumb = function( index ) {

			var bu = $("meta[ name = product-bu ]").attr("content"),
				brand = $("meta[ name = product-brand ]").attr("content"),
				image = $(".product-thumbnails__thumb").eq( index ).find("img").attr("src"),
				regex = new RegExp( "\.com(\.hk|\.cn)*" ),
				cutImage = image.substring( image.search( regex ) ).replace( regex, "" ).match(/[^\/]*$/);

			if ( typeof index !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp hero carousel",
					action: "click thumb",
					label: bu + "_" + brand + "_" + index + " / " + cutImage,
					fieldsObject: {
						nonInteraction: true
					}
				});

			}

		};

		/**
		 * Method for tracking when the hero popup is opened
		 * @param  { Number } index | index hero was opened at
		 *
		 * Type of label is text
		 * https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
		 *
		 * Need to add virtual pageView on enlarged hero popup page.
		 * Ref: Jira Ticket: https://jira-lc.atlassian.net/browse/LC2-126
		 */
		ex.trackHeroPopup = function( index ) {

			var productId = LC.pdp.general.getSelectedProductId(),
				pageName = "on pdp enlarged hero popup - " + productId;

			if ( typeof index !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp hero popup",
					action: "open popup",
					label: index.toString()
				});

			}

			LC.track.trigger( "pageview", {
				pageName: pageName
			});

		};

		/**
		 * Method for tracking when the an info-tab is clicked
		 * @param  { String } name | name of the tab
		 */
		ex.trackInfoTab = function( name ) {

			if ( typeof name !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp product info",
					action: "open tab",
					label: name
				});

			}

		};

		/**
		 * Method for tracking when the an info-accordion is clicked
		 * @param  { String } name | name of the tab
		 */
		ex.trackInfoAccordion = function( name ) {

			if ( typeof name !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "pdp product info",
					action: "open accordion",
					label: name
				});

			}

		};

		/**
		 * Method for tracking when the size converter run
		 * @param { string } country | country
		 */
		ex.trackingSizeConverter = function( country ) {

			if ( typeof country !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "Product Page",
					action: "size converter",
					label: country
				});

			}

		};

		/**
		 * Method for tracking when the check in-store availability run
		 * @param { string } size | size
		 */
		ex.trackClickInStoreAvailability = function( size ) {

			if ( typeof size !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "Product Page",
					action: "check store availability",
					label: size
				});

			}

		};

		ex.trackClickAddWishlist = function( productId ) {

			if ( typeof productId !== "undefined" ) {

				LC.track.trigger("ga.event", {
					category: "Product Page",
					action: "add to wishlist",
					label: productId
				});

			}

		};

		ex.subscribe = function() {

			LC.pubsub.on("pdp.update", function( e, data ) {

				// only fire the tracking if the productId changed
				if ( data.isDifferent ) {

					_this.hkSalePrice = data.response.atgResponse.priceInfo.hkSalePrice;
					ex.trackRefresh( data.response.atgResponse );

				}

			});

			LC.pubsub.on("pdp.addToCart", function( e, data ) {
				ex.trackAddToCart( data );
			});

			LC.pubsub.on("pdp.addProduct", function( e, data ) {
				ex.trackAddProduct( data );
			});

			LC.pubsub.on("pdp.addGiftcard", function( e, data ) {
				ex.trackAddGiftcard( data );
			});

			LC.pubsub.on("pdp.openInformationTab", function( e, data ) {
				ex.trackInfoTab( data.name );
			});

			LC.pubsub.on("pdp.openInformationAccordion", function( e, data ) {
				ex.trackInfoAccordion( data.name );
			});

			LC.pubsub.on("pdp.trackConversion", function( e, data ) {
				ex.trackingSizeConverter( data.country );
			});

			LC.pubsub.on("pdp.trackClickInStoreAvailability", function( e, data ) {
				ex.trackClickInStoreAvailability( data.size );
			});

			LC.pubsub.on("pdp.trackClickAddWishlist", function( e, data ) {
				ex.trackClickAddWishlist( data.productId );
			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));


/**
 *
 * [ module ]
 * pdp -> wishlist
 *
 * used for showing/hiding the wishlist buttons
 * depending on the state of the user's wishlist
 *
 */

( function( LC, $ ) {

	"use strict";

	LC.pdp = LC.pdp || {};

	LC.pdp.wishlist = lcmodule( function( exports ) {

		exports.moduleName = "pdp.wishlist";

		// "exports" is always passed in, and always
		// returned at the end. Bind "ex" as it's easier to type
		// "_this" is used for private binding and maintaining scope

		var ex = exports = $.extend( {}, window.lcmoduledefaults, exports ),
			_this = {};



		/**
		 * initialise the wishlist module.
		 * this module is for handling pdp-only wishlist functionality,
		 * not user-interactions (such as button clicks)
		 */
		ex.init = function() {

			_this.$buttons = 	$(".product-actions__wishlist");
			_this.$addBtn = 	$("#btnWishlist");
			_this.$viewBtn = 	$("#btnViewWishlist");

			_this.pdpdata = 		$("#pdpdata").data();
			_this.wishlistData = 	$("#wishlistdata").data();

			ex.initialState();
			ex.subscribe();

		};

		ex.initialState = function() {

			_this.selectedSku = _this.pdpdata.defaultsizesku;
			ex.updateui();

		};

		/**
		 * return if the skuid exists in the wishlist.
		 * @param  {String} skuId  | the skuid to check if exists
		 * @return {Boolean}       | the giftlistId or false
		 */
		ex.itemInWishlist = function( skuId ) {

			return LC.wishlist.general.itemInAnyWishlist( skuId );

		};

		ex.getWishlistContainingProduct = function( skuId ) {

			var skuIsValid = LC.helpers.isSku( skuId ),
				wishlistId;

			if ( _this.whichListAdded ) {

				// check if the user added the item to a wishlist recently,
				// and if so, then we update the button with that id.
				wishlistId = _this.whichListAdded;

			} else if ( skuIsValid ) {

				// otherwise, we check all their wishlists for the item
				// and get the first wishlist where it exists.
				wishlistId = ex.itemInWishlist( skuId );

			}

			return wishlistId;

		};

		/**
		 * small method for correctly displaying the
		 * wishlist buttons.
		 */
		ex.updateui = function() {

			// update the ui only after the wishlists
			// have finished downloading, this is to prevent errors.
			LC.wishlist.general.onReady().done( function() {

				var sku = _this.selectedSku,
					skuIsSelected = LC.helpers.isSku( sku ),
					wishlistId = ex.getWishlistContainingProduct( sku );

				if ( skuIsSelected && wishlistId ) {

					ex.updateButtonUrl( wishlistId );
					ex.viewWishlist();

				} else {

					ex.addToWishlist();

				}

			});

		};

		ex.addToWishlist = function() {

			_this.$buttons.removeClass( "product-actions__wishlist--added" );
			_this.$viewBtn.addClass( ex.hiddenClass );

			_this.$addBtn.addClass( "link" )
				.removeClass( ex.hiddenClass + " btn--invert" )
				.removeAttr( "title" );

		};

		ex.viewWishlist = function() {

			_this.$buttons.addClass( "product-actions__wishlist--added" );
			_this.$viewBtn.removeClass( ex.hiddenClass );

			_this.$addBtn.removeClass( ex.hiddenClass + " link" )
				.addClass( "btn--invert" )
				.attr( "title", _this.$addBtn.data( "txtaddtowishlist" ) );

		};

		/**
		 * Amend the href of the view wishlist button so that
		 * if the user clicks it, they go directly to the
		 * wishlist which that product exists in
		 */
		ex.updateButtonUrl = function( wishlistId ) {

			var url = _this.$viewBtn.attr( "href" );

			if ( wishlistId ) {

				url = new URI( url );
				url.path( "/wishlist/" + wishlistId );
				url = url.toString();

				_this.$viewBtn.attr( "href", url );

			}

		};

		ex.subscribe = function() {

			LC.pubsub.on( "wishlist.downloaded", ex.updateui );

			LC.pubsub.on(
				"pdp.initSizeSelect " +
				"pdp.chooseSize " +
				"pdp.chooseColor ",
				function( e, data ) {

					// update the selected SKu and the user-interface
					// any time the page initialises, or user changes
					// size/color. If no sku is passed through, then we
					// set undefined so the UI shows the correct state.

					if ( data.skuId && data.skuId !== "" ) {

						_this.selectedSku = data.skuId;

					} else {

						_this.selectedSku = undefined;

					}

					ex.updateui();

				});

			/**
			 * Whenever an item is successfully added to the
			 * wishlist, we update the list item was added to and
			 * the UI for add/view.
			 */
			LC.pubsub.on("wishlist.itemAdded", function( e, data ) {

				_this.whichListAdded = data.wishlistId;
				ex.updateui();

			});

			/**
			 * Whenever an item is successfully removed from the
			 * wishlist, we update the UI for the wishlist button (view/add).
			 */
			LC.pubsub.on("wishlist.itemRemoved", function( e, data ) {

				ex.updateui();

			});

		};

		return exports;

	}({}));

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=pdp.js
